function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos()
}
window.theme = window.theme || {}, window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(e, t) {
            var i = $(e),
                a = i.attr("data-section-id"),
                s = i.attr("data-section-type");
            if (t = t || this.constructors[s], !_.isUndefined(t)) {
                var o = _.assignIn(new t(e), {
                    id: a,
                    type: s,
                    container: e
                });
                this.instances.push(o)
            }
        },
        _onSectionLoad: function(e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t)
        },
        _onSectionUnload: function(i) {
            this.instances = _.filter(this.instances, function(e) {
                var t = e.id === i.detail.sectionId;
                return t && _.isFunction(e.onUnload) && e.onUnload(i), !t
            })
        },
        _onSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
        },
        _onDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
        },
        _onBlockSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
        },
        _onBlockDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
        },
        register: function(e, i) {
            this.constructors[e] = i, $("[data-section-type=" + e + "]").each(function(e, t) {
                this._createInstance(t, i)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function(e) {
            e.$tables.wrap('<div class="' + e.tableWrapperClass + '"></div>')
        },
        wrapIframe: function(e) {
            e.$iframes.each(function() {
                $(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'), this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(e) {
            var t = "js-focus-hidden";
            e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", function() {
                e.first().removeClass(t).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(e) {
                this.pageLinkFocus($(e.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(e, function(e) {
                t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
            })
        },
        removeTrapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
        }
    }, theme.Images = {
        preload: function(e, t) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var a = e[i];
                this.loadImage(this.getSizedImageUrl(a, t))
            }
        },
        loadImage: function(e) {
            (new Image).src = e
        },
        switchImage: function(e, t, i) {
            var a = this.imageSize(t.src),
                s = this.getSizedImageUrl(e.src, a);
            i ? i(s, e, t) : t.src = s
        },
        imageSize: function(e) {
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null !== t ? void 0 !== t[2] ? t[1] + t[2] : t[1] : null
        },
        getSizedImageUrl: function(e, t) {
            if (null === t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null !== i) {
                var a = e.split(i[0]),
                    s = i[0];
                return this.removeProtocol(a[0] + "_" + t + s)
            }
            return null
        },
        removeProtocol: function(e) {
            return e.replace(/http(s)?:/, "")
        }
    }, theme.Currency = {
        formatMoney: function(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var i = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                s = t || "${{amount}}";

            function o(e, t, i, a) {
                if (i = i || ",", a = a || ".", isNaN(e) || null === e) return 0;
                var s = (e = (e / 100).toFixed(t)).split(".");
                return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? a + s[1] : "")
            }
            switch (s.match(a)[1]) {
                case "amount":
                    i = o(e, 2);
                    break;
                case "amount_no_decimals":
                    i = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = o(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    i = o(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    i = o(e, 2, "'")
            }
            return s.replace(a, i)
        }
    }, slate.Variants = function() {
        function e(e) {
            this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                    var t = $(e),
                        i = t.attr("type"),
                        a = {};
                    return "radio" === i || "checkbox" === i ? !!t[0].checked && (a.value = t.val(), a.index = t.data("index"), a) : (a.value = t.val(), a.index = t.data("index"), a)
                });
                return e = _.compact(e)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants;
                return _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                })
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $(this.originalSelectorId, this.$container).val(e.id)
            }
        }), e
    }(), theme.Drawers = function() {
        function e(e, t, i) {
            var a = {
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + t
            };
            if (this.nodes = {
                    $parent: $("html").add("body"),
                    $page: $("#PageContainer")
                }, this.config = $.extend(a, i), this.position = t, this.$drawer = $("#" + e), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        }
        return e.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, e.prototype.open = function(e) {
            var t = !1;
            return e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, e.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents())
        }, e.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
                return 27 !== e.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this))
        }, e.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, e
    }(), window.theme = window.theme || {}, theme.Search = function() {
        var l = {
                search: ".site-header-search, .mobile-header__search",
                searchInput: ".search__input",
                searchSubmit: ".search__submit",
                searchSelect: ".search__select",
                searchToggle: ".search__toggle",
                searchScreen: ".search__fullscreen",
                searchAjax: "form.search__ajax:not(.search__ajax-disabled)",
                searchResults: ".search__results"
            },
            d = {};
        return {
            init: function() {
                $(l.search).length && (function() {
                    if ($(l.searchSubmit).length) {
                        var e = $(l.searchSubmit).outerWidth() + $(l.searchSelect).outerWidth();
                        theme.settings.rtl ? $(l.searchInput).css("padding-left", e) : $(l.searchInput).css("padding-right", e)
                    }
                    $(l.searchInput).focus(function() {
                        $(this).closest(".site-header-search2").addClass("focused-disable")
                    }).blur(function() {
                        $(this).closest(".site-header-search2").removeClass("focused-disable")
                    })
                }(), $(l.searchAjax).each(function() {
                    var i = $(this),
                        s = i.find(l.searchInput),
                        e = null,
                        o = function(e) {
                            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&")
                        },
                        n = i.data("limit"),
                        r = i.data("featured"),
                        c = i.data("featured_limit");
                    s.on("keyup", function() {
                        clearTimeout(e), e = setTimeout(function() {
                            var a = s.val();
                            if (a.length)
                                if (a in d) {
                                    var e = d[a];
                                    $(l.searchResults).html(e.html), $(l.searchResults).find(".product__title").each(function() {
                                        var e = $(this).html(),
                                            t = "(" + o(a) + ")",
                                            i = e.replace(new RegExp(t, "gi"), "<strong>$1</strong>");
                                        $(this).html(i)
                                    })
                                } else {
                                    var t = {
                                        view: "search",
                                        type: "product",
                                        searched_limit: n,
                                        featured: r,
                                        featured_limit: c,
                                        q: "*" + a + "*"
                                    };
                                    $.ajax({
                                        url: "/search",
                                        data: t,
                                        dataType: "html",
                                        type: "GET",
                                        beforeSend: function() {
                                            i.addClass("loading")
                                        },
                                        complete: function() {
                                            i.removeClass("loading")
                                        },
                                        success: function(e) {
                                            $(l.searchResults).html(e), $(l.searchResults).find(".product__title").each(function() {
                                                var e = $(this).html(),
                                                    t = "(" + o(a) + ")",
                                                    i = e.replace(new RegExp(t, "gi"), "<strong>$1</strong>");
                                                $(this).html(i)
                                            }), d[a] = {
                                                found: !0,
                                                html: e
                                            }
                                        }
                                    })
                                }
                            else $(l.searchResults).empty()
                        }, 500)
                    }), $(document).mouseup(function(e) {
                        var t = $(l.searchResults);
                        t.is(e.target) || 0 !== t.has(e.target).length || t.empty()
                    })
                }), $(l.searchToggle).click(function(e) {
                    e.preventDefault(),
                        function(e) {
                            if ($(l.searchScreen).length) {
                                var t = $(e).closest(".site-header"),
                                    i = t.outerHeight(),
                                    a = t.find(".site-header__bottom").outerHeight(),
                                    s = i;
                                s = 0 < a ? i - a - 10 : i - 1, $(l.searchScreen).css("top", s)
                            }
                        }(this);
                    var t = $("body"),
                        i = $(this).closest(".site-header-search");
                    i.hasClass("opened") ? (t.removeClass("search-opened"), i.removeClass("opened")) : (t.addClass("search-opened"), i.addClass("opened"), $(l.searchInput, i).val(""), setTimeout(function() {
                        $(l.searchInput, i).focus()
                    }, 300))
                }), $(document).keyup(function(e) {
                    if (27 == e.keyCode) {
                        var t = $(l.search);
                        t.hasClass("opened") && ($("body").removeClass("search-opened"), t.removeClass("opened"))
                    }
                }), $(document).mouseup(function(e) {
                    var t = $(l.searchToggle),
                        i = $(l.searchScreen);
                    if (!t.is(e.target) && 0 === t.has(e.target).length && !i.is(e.target) && 0 === i.has(e.target).length) {
                        var a = $(l.search);
                        a.hasClass("opened") && ($("body").removeClass("search-opened"), a.removeClass("opened"))
                    }
                }))
            }
        }
    }(), theme.CurrencyPicker = function() {
        var s = {
                selector: ".money",
                container: ".currency__picker",
                currency: ".currency__picker .currency__switcher",
                currencyPicker: ".currency__picker .currency",
                currencyActive: ".currency__picker .currency.active",
                currencyCurrent: ".currency__picker .currency__current",
                currencyNotification: ".currency__notification"
            },
            o = {
                currency_format: "",
                shop_currency: "",
                default_currency: "",
                money_with_currency_format: "",
                money_format: "",
                auto_switch: "true",
                original_price: "true"
            };

        function n() {
            if ("false" == o.original_price) return !1;
            var i = Currency.currentCurrency,
                e = Currency.cookie.read(),
                a = o.shop_currency;
            e && (i = e), $(s.selector).each(function() {
                var e = $(this);
                if (e.removeAttr("data-currency-default"), a != i) {
                    var t = e.attr("data-currency-" + a);
                    "USD" == a && (t += " USD"), e.attr("data-currency-default", t)
                }
            })
        }

        function r() {
            $(s.currencyNotification).length && (Currency.currentCurrency != o.shop_currency ? $(s.currencyNotification).each(function() {
                var e = $(this),
                    t = e.data("html"),
                    i = "<strong>" + Currency.currentCurrency + "</strong>";
                t = t.replace(new RegExp("{{ current_currency }}", "g"), i), e.html(t), e.hasClass("loaded") || e.addClass("loaded").slideDown()
            }) : $(s.currencyNotification).removeClass("loaded").slideUp())
        }
        return {
            init: function() {
                if ($(s.currency).length) {
                    var e = $(s.container);
                    o.currency_format = e.find(".currency_format").val(), o.shop_currency = e.find(".shop_currency").val(), o.default_currency = e.find(".default_currency").val(), o.money_with_currency_format = e.find(".money_with_currency_format").val(), o.money_format = e.find(".money_format").val(), o.auto_switch = e.find(".auto_switch").val(), o.original_price = e.find(".original_price").val(), Currency.format = o.currency_format;
                    var t = o.shop_currency;
                    Currency.moneyFormats[t].money_with_currency_format = o.money_with_currency_format, Currency.moneyFormats[t].money_format = o.money_format;
                    var i = o.default_currency,
                        a = Currency.cookie.read();
                    $(".money .money").each(function() {
                        $(this).parents(".money").removeClass("money")
                    }), $(s.selector).each(function() {
                        var e = $(this);
                        if (void 0 === e.attr("data-currency-" + o.shop_currency)) {
                            var t = e.text();
                            e.attr("data-currency-" + o.shop_currency, t)
                        }
                    }), null == a ? t !== i ? Currency.convertAll(t, i, s.selector) : Currency.currentCurrency = i : $(s.currency).length && 0 === $(s.currency + " .currency[data-code=" + a + "]").size() ? (Currency.currentCurrency = t, Currency.cookie.write(t)) : a === t ? Currency.currentCurrency = t : Currency.convertAll(t, a, s.selector), $(s.currency).on("click", ".currency:not(.active)", function() {
                        var e = $(this).data("code");
                        Currency.convertAll(Currency.currentCurrency, e, s.selector), $(s.currencyPicker).removeClass("active"), $(this).addClass("active"), $(s.currencyCurrent).text(Currency.currentCurrency).attr("data-code", Currency.currentCurrency), n(), r()
                    }), window.selectCallback, $(s.currencyPicker).removeClass("active"), $(s.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(s.currencyCurrent).text(Currency.currentCurrency).attr("data-code", Currency.currentCurrency), n(), "false" != o.auto_switch && null == Currency.cookie.read() && $.getJSON("//ipinfo.io/json", function(e) {
                        var t = JSON.parse(JSON.stringify(e, null, 2));
                        void 0 !== t.country && $.getJSON("//restcountries.eu/rest/v1/alpha/" + t.country, function(e) {
                            var t = e.currencies[0];
                            $(s.currencyPicker + '[data-code="' + t + '"]').trigger("click")
                        })
                    }), r()
                }
            },
            convert: function(e) {
                $(s.currency).length && ($(e).each(function() {
                    var e = $(this);
                    if (void 0 === e.attr("data-currency-" + o.shop_currency)) {
                        var t = e.text();
                        e.attr("data-currency-" + o.shop_currency, t)
                    }
                }), Currency.convertAll(o.shop_currency, $(s.currencyActive).attr("data-code"), e, o.currency_format), n())
            },
            convertAll: function() {
                $(s.currency).length && ($(s.selector).each(function() {
                    var e = $(this);
                    if (void 0 === e.attr("data-currency-" + o.shop_currency)) {
                        var t = e.text();
                        e.attr("data-currency-" + o.shop_currency, t)
                    }
                }), Currency.convertAll(o.shop_currency, $(s.currencyActive).attr("data-code"), s.selector), n())
            }
        }
    }(), theme.LanguagePicker = function() {
        var r = {
            language: ".language__picker .language__switcher",
            languagePicker: ".language__picker .language",
            languageCurrent: ".language__picker .language__current",
            selector: "#weketing_google_translate_element"
        };

        function c(e) {
            $(r.selector + " .goog-te-combo").val(e);
            var t, i = document.getElementsByClassName("goog-te-combo")[0];
            document.createEvent ? ((t = document.createEvent("HTMLEvents")).initEvent("change", !0, !0), i.dispatchEvent(t)) : ((t = document.createEventObject()).eventType = "change", i.fireEvent("on" + t.eventType, t))
        }

        function e() {
            var e = weketingJS.settingsJS[8];
            if ("yes" == e.enable) {
                for (var t = e.default_language, i = e.custom_languages, a = weketingSGT.languages(), s = localStorage.getItem("roarStorage_language"), o = 0; o < i.length - 1; o++)
                    if (i[o] == t) {
                        i.pop();
                        break
                    } for (o = 0; o < i.length; o++)
                    if (i[o] == s) {
                        t = s;
                        break
                    } for (o = 0; o < i.length; o++) {
                    var n = '<li class="language active notranslate" data-code="' + t + '">' + a[t] + "</li>";
                    i[o] != t && (n = '<li class="language notranslate" data-code="' + i[o] + '">' + a[i[o]] + "</li>"), $(r.language).append(n)
                }
                $(r.languageCurrent).text(a[t]), c(t)
            }
        }
        return {
            init: function() {
                $(r.language).length && $(r.selector).length && ("undefined" != typeof weketingJS && void 0 !== weketingJS.settingsJS[8] ? e() : $(r.selector).bind("google_translate", function() {
                    e()
                }), $("body").on("click", r.languagePicker + ":not(.active)", function() {
                    var e = $(this).data("code");
                    if ("" != e) {
                        var t = $(this).text();
                        $(r.languagePicker).removeClass("active"), $(r.languagePicker + '[data-code="' + e + '"]').addClass("active"), $(r.languageCurrent).text(t), localStorage.setItem("roarStorage_language", e), c(e)
                    }
                }))
            }
        }
    }(), theme.MiniCart = function() {
        var l = {
            headerCart: ".site-header-cart",
            miniCart: ".minicart",
            miniCartAgree: ".minicart .cart__agree",
            miniCartCheckout: ".minicart .btn-checkout",
            miniCartRemove: ".minicart .item__remove",
            miniCartClose: ".minicart .cart__close"
        };

        function s(a) {
            void 0 === a && (a = 0), $(l.miniCart).addClass("loading"), $.get("/search", function(e) {
                var t = $(e).find(l.headerCart);
                $(l.headerCart).html(t.html());
                var i = $(e).find(l.miniCart);
                ($(l.miniCart).removeClass("loading").html(i.html()), 0 < a) && $(".product__" + a + " .addcart_btn").removeClass("added")
            })
        }
        return {
            init: function() {
                $(document).on("click", l.headerCart, function(e) {
                    var t = $(this);
                    if ($(l.miniCart).length) {
                        e.preventDefault();
                        var i = t.parent().find(l.miniCart);
                        if ($(l.miniCart).each(function() {
                                i.attr("id") != $(this).attr("id") && $(this).removeClass("opened")
                            }), i.hasClass("opened")) i.removeClass("opened");
                        else if (i.addClass("opened"), i.hasClass("minicart-frame")) {
                            var a = $(window).scrollTop(),
                                s = t.offset(),
                                o = t.outerWidth(),
                                n = s.top - a + 50;
                            if (i.css("top", n), $("body").hasClass("site-rtl")) {
                                var r = s.left;
                                i.css("right", "auto").css("left", r)
                            } else {
                                var c = $(window).outerWidth() - s.left - o;
                                i.css("left", "auto").css("right", c)
                            }
                        }
                    }
                }), $(document).on("change", l.miniCartAgree, function(e) {
                    $(this).is(":checked") ? ($(l.miniCartAgree).prop("checked", !0), $(l.miniCartCheckout).removeClass("btn-disabled")) : ($(l.miniCartAgree).prop("checked", !1), $(l.miniCartCheckout).addClass("btn-disabled"))
                }), $(document).on("click", l.miniCartCheckout, function(e) {
                    if ($(l.miniCartAgree).length) {
                        var t = $(l.miniCartAgree);
                        if (!t.is(":checked")) {
                            var i = t.data("message");
                            alert(i), e.preventDefault()
                        }
                    }
                }), $(document).on("click", l.miniCartRemove, function(e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.attr("href"),
                        a = t.data("product_id");
                    $(l.miniCart).addClass("loading"), $.post(i, function() {
                        s(a)
                    })
                }), $(document).on("click", l.miniCartClose, function() {
                    $(l.miniCart).removeClass("loading").removeClass("opened")
                }), $(document).mouseup(function(e) {
                    var t = $(l.headerCart),
                        i = $(l.miniCart);
                    i.is(e.target) || 0 !== i.has(e.target).length || t.is(e.target) || 0 !== t.has(e.target).length || i.hasClass("opened") && i.removeClass("opened")
                })
            },
            update: s,
            open: function() {
                $(l.miniCart).length && !$(l.miniCart).hasClass("opened") && $(l.headerCart).trigger("click")
            }
        }
    }(),
    function() {
        var e = $(".return-link");

        function i(e) {
            var t = document.createElement("a");
            return t.ref = e, t.hostname
        }
        document.referrer && e.length && window.history.length && e.one("click", function(e) {
            e.preventDefault();
            var t = i(document.referrer);
            return i(window.location.href) === t && history.back(), !1
        })
    }(), theme.Slideshow = function() {
        this.$slideshow = null;
        var h = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };

        function e(e) {
            this.$slideshow = $(e), this.$wrapper = this.$slideshow.closest("." + h.wrapper), this.$pause = this.$wrapper.find("." + h.pauseButton);
            this.$slideshow.data("autoplay"), parseInt(this.$slideshow.data("speed")), parseInt(this.$slideshow.data("per_view"));
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                autoplay: this.$slideshow.data("autoplay") || !1,
                speed: parseInt(this.$slideshow.data("speed")) || 7e3,
                per_view: parseInt(this.$slideshow.data("per_view")) || 1,
                sliderImagesActive: !1
            }, this.initBreakpoints()
        }

        function p(e) {
            return e.find("." + h.video).length
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            initBreakpoints: function() {
                var e = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider()
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider(!1)
                    }
                })
            },
            destroyImageSlider: function() {
                $(this.$slideshow).slick("unslick"), this.settings.sliderImagesActive = !1
            },
            initImageSlider: function(e) {
                void 0 === e && (e = !0);
                var t = {
                    rtl: !1,
                    accessibility: !0,
                    arrows: !0,
                    dots: !1,
                    fade: !this.settings.per_view,
                    draggable: !0,
                    touchThreshold: 20,
                    autoplay: this.settings.autoplay,
                    autoplaySpeed: this.settings.speed,
                    slidesToShow: this.settings.per_view,
                    slidesToScroll: 1
                };
                1 == e && (t = {
                    rtl: !1,
                    accessibility: !0,
                    arrows: !0,
                    dots: !1,
                    fade: !1,
                    draggable: !0,
                    touchThreshold: 20,
                    autoplay: this.settings.autoplay,
                    autoplaySpeed: this.settings.speed,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }), this.$slideshow.on("beforeChange", function(e, t, i, a) {
                    var s = t.$slider,
                        o = s.find("." + h.currentSlide),
                        n = s.find('.slideshow__slide[data-slick-index="' + a + '"]');
                    if (p(o)) {
                        var r = o.find("." + h.video),
                            c = r.attr("id");
                        theme.SlideshowVideo.pauseVideo(c), r.attr("tabindex", "-1")
                    }
                    if (p(n)) {
                        var l = n.find("." + h.video),
                            d = l.attr("id"),
                            u = l.hasClass(h.videoBackground);
                        u ? theme.SlideshowVideo.playVideo(d) : l.attr("tabindex", "0")
                    }
                }.bind(this)), this.$slideshow.on("init", function(e, t) {
                    var i = t.$slider,
                        a = t.$list,
                        s = this.$wrapper,
                        o = this.settings.autoplay;
                    a.removeAttr("aria-live"), s.on("focusin", function(e) {
                        s.has(e.target).length && (a.attr("aria-live", "polite"), o && i.slick("slickPause"))
                    }), s.on("focusout", function(e) {
                        if (s.has(e.target).length && (a.removeAttr("aria-live"), o)) {
                            if ($(e.target).hasClass(h.closeVideoBtn)) return;
                            i.slick("slickPlay")
                        }
                    }), t.$dots && t.$dots.on("keydown", function(e) {
                        37 === e.which && i.slick("slickPrev"), 39 === e.which && i.slick("slickNext"), 37 !== e.which && 39 !== e.which || t.$dots.find(".slick-active button").focus()
                    })
                }.bind(this)), this.$slideshow.slick(t), this.$pause.on("click", this.togglePause.bind(this)), this.settings.sliderImagesActive = !0
            },
            togglePause: function() {
                var e = "#Slideshow-" + this.$pause.data("id");
                this.$pause.hasClass(h.isPaused) ? (this.$pause.removeClass(h.isPaused), $(e).slick("slickPlay")) : (this.$pause.addClass(h.isPaused), $(e).slick("slickPause"))
            }
        }), e
    }(), theme.SlideshowVideo = function() {
        var u = !1,
            h = !1,
            i = !1,
            p = !1,
            a = !1,
            m = {},
            f = [],
            o = {
                ratio: 16 / 9,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(e) {
                        e.target.setPlaybackQuality("hd1080");
                        var t = c(e);
                        switch (i || ($(window).width() < 750 ? p = !0 : window.mobileCheck() && (p = !0), p && v(!1), i = !0), $("#" + t.id).attr("tabindex", "-1"), l(), t.type) {
                            case "background-chrome":
                            case "background":
                                e.target.mute(), t.$parentSlide.closest("." + g.slickSlide).hasClass(g.currentSlide) && s(t.id)
                        }
                        t.$parentSlide.addClass(g.loaded)
                    },
                    onStateChange: function(e) {
                        var t = c(e);
                        switch (e.data) {
                            case 0:
                                ! function(e) {
                                    switch (e.type) {
                                        case "background":
                                            f[e.id].seekTo(0);
                                            break;
                                        case "background-chrome":
                                            f[e.id].seekTo(0), n(e.id);
                                            break;
                                        case "chrome":
                                            n(e.id)
                                    }
                                }(t);
                                break;
                            case 1:
                                _(t);
                                break;
                            case 2:
                                r(t)
                        }
                    }
                }
            },
            g = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickSlide: "slick-slide",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay"
            };

        function s(e, t) {
            var i, a, s, o, n, r, c = m[e],
                l = f[e],
                d = m[e].$parentSlide;
            if (p) _(c);
            else if (t || u && h) return d.removeClass(g.loading), _(c), void l.playVideo();
            u || (a = d, (i = l).playVideo(), (s = i, r = $.Deferred(), o = setInterval(function() {
                s.getCurrentTime() <= 0 || (h = !0, clearInterval(o), clearTimeout(n), r.resolve())
            }, 500), n = setTimeout(function() {
                clearInterval(o), r.reject()
            }, 4e3), r).then(function() {
                v(!0)
            }).fail(function() {
                v(!1), i.stopVideo()
            }).always(function() {
                u = !0, a.removeClass(g.loading)
            }))
        }

        function v(e) {
            var t = e ? g.supportsAutoplay : g.supportsNoAutoplay;
            $(document.documentElement).addClass(t), e || (p = !0), u = !0
        }

        function _(e) {
            var t = e.$parentSlideshowWrapper,
                i = e.$parentSlide;
            if (i.removeClass(g.loading), "background" !== e.status) {
                switch ($("#" + e.id).attr("tabindex", "0"), e.type) {
                    case "chrome":
                    case "background-chrome":
                        t.removeClass(g.paused).addClass(g.playing), i.removeClass(g.paused).addClass(g.playing)
                }
                i.find("." + g.closeVideoBtn).focus()
            }
        }

        function r(e) {
            var t = e.$parentSlideshowWrapper,
                i = e.$parentSlide;
            "background-chrome" !== e.type ? ("closed" !== e.status && "background" !== e.type && (t.addClass(g.paused), i.addClass(g.paused)), "chrome" === e.type && "closed" === e.status && (t.removeClass(g.paused), i.removeClass(g.paused)), t.removeClass(g.playing), i.removeClass(g.playing)) : n(e.id)
        }

        function n(e) {
            var t, i, a = m[e],
                s = a.$parentSlideshowWrapper,
                o = a.$parentSlide,
                n = [g.pause, g.playing].join(" ");
            switch ($("#" + a.id).attr("tabindex", "-1"), a.status = "closed", a.type) {
                case "background-chrome":
                    f[e].mute(), t = e, i = $("#" + t).addClass(g.videoBackground).removeClass(g.videoChrome), m[t].$parentSlide.addClass(g.slideBackgroundVideo), m[t].status = "background", d(i);
                    break;
                case "chrome":
                    f[e].stopVideo(), r(a)
            }
            s.removeClass(n), o.removeClass(n)
        }

        function c(e) {
            return m[e.target.h.id]
        }

        function t(t) {
            var e, i = m[t];
            switch (i.$parentSlide.addClass(g.loading), i.status = "open", i.type) {
                case "background-chrome":
                    e = t, $("#" + e).removeAttr("style").removeClass(g.videoBackground).addClass(g.videoChrome), m[e].$parentSlideshowWrapper.removeClass(g.slideBackgroundVideo).addClass(g.playing), m[e].$parentSlide.removeClass(g.slideBackgroundVideo).addClass(g.playing), m[e].status = "open", f[t].unMute(), s(t, !0);
                    break;
                case "chrome":
                    s(t, !0)
            }
            $(document).on("keydown.videoPlayer", function(e) {
                27 === e.keyCode && n(t)
            })
        }

        function l() {
            $("." + g.videoBackground).each(function(e, t) {
                d($(t))
            })
        }

        function d(e) {
            var t = e.closest("." + g.slide);
            if (!t.hasClass(g.slickClone)) {
                var i = t.width(),
                    a = e.width(),
                    s = e.height();
                i / o.ratio < s ? (a = Math.ceil(s * o.ratio), e.width(a).height(s).css({
                    left: (i - a) / 2,
                    top: 0
                })) : (s = Math.ceil(i / o.ratio), e.width(i).height(s).css({
                    left: 0,
                    top: (s - s) / 2
                })), e.prepareTransition().addClass(g.loaded)
            }
        }

        function y() {
            $(document).on("click.videoPlayer", "." + g.playVideoBtn, function(e) {
                t($(e.currentTarget).data("controls"))
            }), $(document).on("click.videoPlayer", "." + g.closeVideoBtn, function(e) {
                n($(e.currentTarget).data("controls"))
            }), $(window).on("resize.videoPlayer", $.debounce(250, function() {
                a && l()
            }))
        }
        return {
            init: function(e) {
                if (e.length && (m[e.attr("id")] = {
                        id: e.attr("id"),
                        videoId: e.data("id"),
                        type: e.data("type"),
                        status: "chrome" === e.data("type") ? "closed" : "background",
                        videoSelector: e.attr("id"),
                        $parentSlide: e.closest("." + g.slide),
                        $parentSlideshowWrapper: e.closest("." + g.slideshowWrapper),
                        controls: "background" === e.data("type") ? 0 : 1,
                        slideshow: e.data("slideshow")
                    }, !a)) {
                    var t = document.createElement("script");
                    t.src = "https://www.youtube.com/iframe_api";
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(t, i)
                }
            },
            loadVideos: function() {
                for (var e in m)
                    if (m.hasOwnProperty(e)) {
                        var t = $.extend({}, o, m[e]);
                        t.playerVars.controls = t.controls, f[e] = new YT.Player(e, t)
                    } y(), a = !0
            },
            loadVideo: function(e) {
                if (a) {
                    var t = $.extend({}, o, m[e]);
                    t.playerVars.controls = t.controls, f[e] = new YT.Player(e, t), y()
                }
            },
            playVideo: function(e) {
                (i || p) && e && "function" == typeof f[e].playVideo && s(e)
            },
            pauseVideo: function(e) {
                f[e] && "function" == typeof f[e].pauseVideo && f[e].pauseVideo()
            },
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(),
    function() {
        var e = $("#BlogTagFilter");
        e.length && e.on("change", function() {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        function t() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
        }
        return {
            init: function() {
                var e;
                "#recover" === window.location.hash && t(), $(document).on("click", "#RecoverPassword", function(e) {
                    e.preventDefault(), t()
                }), $(document).on("click", "#HideRecoverPasswordLink", function(e) {
                    e.preventDefault(), t()
                }), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), (e = $("#AddressNewForm")).length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                    hideElement: "AddressProvinceContainerNew"
                }), $(".address-country-option").each(function() {
                    var e = $(this).data("form-id"),
                        t = "AddressCountry_" + e,
                        i = "AddressProvince_" + e,
                        a = "AddressProvinceContainer_" + e;
                    new Shopify.CountryProvinceSelector(t, i, {
                        hideElement: a
                    })
                }), $(".address-new-toggle").on("click", function() {
                    e.toggleClass("hide")
                }), $(".address-edit-toggle").on("click", function() {
                    var e = $(this).data("form-id");
                    $("#EditAddress_" + e).toggleClass("hide")
                }), $(".address-delete").on("click", function() {
                    var e = $(this),
                        t = e.data("form-id"),
                        i = e.data("confirm-message");
                    confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }))
            }
        }
    }(), window.theme = window.theme || {}, theme.Cart = function() {
        var i = "cart--no-cookies";

        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.settings = {
                namespace: "#CartSection-" + t,
                sectionId: t
            }, this.selectors = {
                quantity: ".item__qty-" + t,
                agree: "#cart__agree-" + t,
                checkout: ".cart__checkout-" + t + ' [name="checkout"], .cart__checkout-' + t + ' [name="goto_pp"], .cart__checkout-' + t + ' [name="goto_gc"]',
                remove: ".item__remove-" + t,
                update: ".cart__update-" + t
            }, this._cookiesEnabled() || this.$container.addClass(i), this._qtyCart(), this._checkoutCart(), this._removeCart(), this._updateCart()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _removeCart: function() {
                var a = this;
                $(document).off("click", a.selectors.remove), $(document).on("click", a.selectors.remove, function(e) {
                    e.preventDefault();
                    var t = $(this).attr("href"),
                        i = $(a.settings.namespace);
                    i.addClass("loading"), $.post(t, function() {
                        $.get("/cart?view=popup", function(e) {
                            i.html($(e).find(a.settings.namespace).html()), setTimeout(function() {
                                i.removeClass("loading")
                            }, 100), theme.MiniCart.update(), theme.CartGift.check()
                        })
                    })
                })
            },
            _updateCart: function() {
                var a = this;
                $(document).off("click", a.selectors.update), $(document).on("click", a.selectors.update, function(e) {
                    e.preventDefault();
                    var t = $(this).closest("form"),
                        i = $(a.settings.namespace);
                    return $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        async: !0,
                        cache: !1,
                        data: t.serialize(),
                        dataType: "json",
                        beforeSend: function() {
                            i.addClass("loading")
                        },
                        success: function(e) {
                            $.get("/cart?view=popup", function(e) {
                                i.html($(e).find(a.settings.namespace).html()), setTimeout(function() {
                                    i.removeClass("loading")
                                }, 100)
                            }), theme.MiniCart.update(), theme.CartGift.check()
                        }
                    }), !1
                })
            },
            _qtyCart: function() {
                $(document).off("click", this.selectors.quantity + " .plus"), $(document).on("click", this.selectors.quantity + " .plus", function() {
                    var e = $(this).parent().find(".qty"),
                        t = parseInt(e.val());
                    t += 1, e.val(t)
                }), $(document).off("click", this.selectors.quantity + " .minus"), $(document).on("click", this.selectors.quantity + " .minus", function() {
                    var e = $(this).parent().find(".qty"),
                        t = parseInt(e.val());
                    0 < t && (t -= 1, e.val(t))
                })
            },
            _checkoutCart: function() {
                var a = this;
                $(document).off("click", a.selectors.checkout), $(document).on("click", a.selectors.checkout, function() {
                    if ($(a.selectors.agree).length) {
                        var e = $(this),
                            t = $(a.selectors.agree);
                        if (!t.is(":checked")) {
                            var i = t.data("message");
                            return alert(i), !1
                        }
                        e.submit()
                    }
                }), $(document).on("change", a.selectors.agree, function(e) {
                    $(this).is(":checked") ? $(a.selectors.checkout).removeClass("btn-disabled") : $(a.selectors.checkout).addClass("btn-disabled")
                })
            },
            _cookiesEnabled: function() {
                var e = navigator.cookieEnabled;
                return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.ShippingCalculator = function() {
        function ShippingCalculator(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.selectors = {
                shipping_btn: "#cart__shipping-btn-" + t,
                shipping_calculator: "#shipping__calculator-" + t,
                get_rates: "#shipping__calculator-btn-" + t,
                response: "#shipping__calculator-response-" + t,
                template: '<p id ="shipping-rates-feedback-' + t + '" class="shipping-rates-feedback"></p>',
                address_country: "address_country-" + t,
                address_province: "address_province-" + t,
                address_zip: "address_zip-" + t,
                address_province_label: "address_province_label-" + t,
                address_province_container: "address_province_container-" + t
            }, this.strings = {
                submitButton: "Calculate shipping",
                submitButtonDisabled: "Calculating...",
                customerIsLoggedIn: !1,
                moneyFormat: "${{amount}}"
            }, this._init()
        }
        return ShippingCalculator.prototype = _.assignIn({}, ShippingCalculator.prototype, {
            _disableButtons: function() {
                var e = this.selectors,
                    t = this.strings;
                $(e.get_rates).text(t.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
            },
            _enableButtons: function() {
                var e = this.selectors,
                    t = this.strings;
                $(e.get_rates).removeAttr("disabled").removeClass("disabled").text(t.submitButton)
            },
            _render: function(e) {
                var t = this.selectors,
                    i = (this.strings, $(t.template)),
                    a = $(t.response);
                if (a.length) {
                    if (e.success)
                        if (i.addClass("success"), e.rates) {
                            i.append(e.rates);
                            var s = e.rates;
                            if (s[0]) {
                                var o = s[0];
                                i.append('Rates start at <span class="money">' + o.price + "</span>.")
                            }
                        } else i.append("We do not ship to this destination.");
                    else i.addClass("error"), i.append(e.errorFeedback);
                    i.appendTo(a), theme.CurrencyPicker.convert(t.response + " .money")
                }
            },
            _formatRate: function(e) {
                this.selectors;
                var t = this.strings;
                if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(e, t.moneyFormat);
                "string" == typeof e && (e = e.replace(".", ""));
                var i = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    s = t.moneyFormat;

                function o(e, t) {
                    return void 0 === e ? t : e
                }

                function n(e, t, i, a) {
                    if (t = o(t, 2), i = o(i, ","), a = o(a, "."), isNaN(e) || null == e) return 0;
                    var s = (e = (e / 100).toFixed(t)).split(".");
                    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? a + s[1] : "")
                }
                switch (s.match(a)[1]) {
                    case "amount":
                        i = n(e, 2);
                        break;
                    case "amount_no_decimals":
                        i = n(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        i = n(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        i = n(e, 0, ".", ",")
                }
                return s.replace(a, i)
            },
            _onCartShippingRatesUpdate: function(e, t) {
                var i = this.selectors;
                this.strings;
                this._enableButtons();
                var a = "";
                if (t.zip && (a += t.zip + ", "), t.province && (a += t.province + ", "), a += t.country, e.length)
                    for (var s = 0; s < e.length; s++) e[s].price = this._formatRate(e[s].price);
                this._render({
                    rates: e,
                    address: a,
                    success: !0
                }), $(i.response).fadeIn()
            },
            _pollForCartShippingRatesForDestination: function(a) {
                var s = this,
                    o = (this.selectors, this.strings, function() {
                        $.ajax("/cart/async_shipping_rates", {
                            dataType: "json",
                            success: function(e, t, i) {
                                200 === i.status ? s._onCartShippingRatesUpdate(e.shipping_rates, a) : setTimeout(o, 500)
                            },
                            error: function(e, t) {
                                s._onError(e, t, s)
                            }
                        })
                    });
                return o
            },
            _fullMessagesFromErrors: function(e) {
                this.selectors, this.strings;
                var a = [];
                return $.each(e, function(i, e) {
                    $.each(e, function(e, t) {
                        a.push(i + " " + t)
                    })
                }), a
            },
            _onError: function(XMLHttpRequest, textStatus, self) {
                var selectors = self.selectors,
                    strings = self.strings;
                self._enableButtons();
                var feedback = "",
                    data = eval("(" + XMLHttpRequest.responseText + ")");
                feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + self._fullMessagesFromErrors(data).join("; ") + ".", "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."), self._render({
                    rates: [],
                    errorFeedback: feedback,
                    success: !1
                }), $(selectors.response).show()
            },
            _getCartShippingRatesForDestination: function(e) {
                var i = this;
                this.selectors, this.strings;
                $.ajax({
                    type: "POST",
                    url: "/cart/prepare_shipping_rates",
                    data: $.param({
                        shipping_address: e
                    }),
                    success: i._pollForCartShippingRatesForDestination(e),
                    error: function(e, t) {
                        i._onError(e, t, i)
                    }
                })
            },
            _init: function() {
                var t = this,
                    i = this.selectors,
                    e = this.strings;
                if ($(i.shipping_calculator).length) {
                    new Shopify.CountryProvinceSelector(i.address_country, i.address_province, {
                        hideElement: i.address_province_container
                    });
                    var a = $("#" + i.address_country),
                        s = $("#" + i.address_province_label).get(0);
                    "undefined" != typeof Countries && (Countries.updateProvinceLabel(a.val(), s), a.change(function() {
                        Countries.updateProvinceLabel(a.val(), s)
                    })), $(i.get_rates).click(function() {
                        t._disableButtons(), $(i.response).empty().hide();
                        var e = {};
                        e.zip = $("#" + i.address_zip).val() || "", e.country = $("#" + i.address_country).val() || "", e.province = $("#" + i.address_province).val() || "", t._getCartShippingRatesForDestination(e)
                    }), e.customerIsLoggedIn && $(i.get_rates + ":eq(0)").trigger("click"), $(i.shipping_btn).click(function() {
                        $(i.shipping_calculator).slideToggle()
                    })
                }
            },
            onUnload: function() {}
        }), ShippingCalculator
    }(), theme.CartGift = function() {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.selectors = {
                gift: "#gift__wrapping-" + t,
                namespace: "#CartSection-" + t,
                redirect: !0
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            check: function() {
                var e = this.selectors;
                switch ($(e.gift).data("gift_case")) {
                    case 1:
                        this.remove();
                        break;
                    case 2:
                    case 3:
                    case 3:
                        this.set()
                }
            },
            set: function() {
                var i = this.selectors,
                    e = $(i.gift).data("product_id"),
                    t = new Object;
                t[e] = 1;
                var a = new Object;
                a["gift-wrapping"] = !0;
                var s = new Object;
                s.updates = t, s.attributes = a, $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: s,
                    dataType: "json",
                    beforeSend: function() {
                        i.redirect || $(i.namespace).addClass("loading")
                    },
                    success: function() {
                        if (i.redirect) location.href = "/cart";
                        else {
                            var t = $(i.namespace);
                            $.get("/cart?view=popup", function(e) {
                                t.html($(e).find(i.namespace).html()), setTimeout(function() {
                                    t.removeClass("loading")
                                }, 100)
                            }), theme.MiniCart.update()
                        }
                    }
                })
            },
            remove: function() {
                var i = this.selectors,
                    e = $(i.gift).data("product_id"),
                    t = new Object;
                t[e] = 0;
                var a = new Object;
                a["gift-wrapping"] = "";
                var s = new Object;
                s.updates = t, s.attributes = a, $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: s,
                    dataType: "json",
                    beforeSend: function() {
                        i.redirect || $(i.namespace).addClass("loading")
                    },
                    success: function() {
                        if (i.redirect) location.href = "/cart";
                        else {
                            var t = $(i.namespace);
                            $.get("/cart?view=popup", function(e) {
                                t.html($(e).find(i.namespace).html()), setTimeout(function() {
                                    t.removeClass("loading")
                                }, 100)
                            }), theme.MiniCart.update()
                        }
                    }
                })
            },
            init: function() {
                var e = this,
                    t = this.selectors;
                0 == $(t.gift).data("redirect") && (this.selectors.redirect = !1), $(t.gift).length && (e.check(), $(document).off("change", t.gift), $(document).on("change", t.gift, function() {
                    $(this).is(":checked") ? e.set() : e.remove()
                }))
            },
            onUnload: function() {}
        }), e
    }(), window.theme = window.theme || {}, theme.Filters = function() {
        var i = "sort_by",
            a = "limit",
            s = "view",
            d = "constraint",
            o = "#PerPage",
            e = "#DefaultPerPage",
            n = "#SortBy",
            t = "#DefaultSortBy",
            r = ".shop__view",
            c = "#site-pagination a.btn",
            l = "#site-pagination button.btn",
            u = ".advanced-filter .filter",
            h = ".site-widget.filtering .clear";

        function p(e) {
            var t = this.$container = $(e);
            this.$limitSelect = $(o, t), this.$sortSelect = $(n, t), this.$selects = $(o, t).add($(n, t)), this.defaultLimit = this._getDefaultLimitValue(), this.defaultSort = this._getDefaultSortValue(), this._resizeSelect(this.$selects), this.$selects.removeClass("hidden"), this.$limitSelect.on("change", this._onLimitChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this)), $(document).on("change", u, this._onFilterChange.bind(this)), $(document).on("click", h, this._onFilterClear.bind(this)), $(document).on("click", c, this._onPageClick.bind(this)), $(document).on("click", l, this._onLoadMoreClick.bind(this)), $(document).on("click", r, this._onViewClick.bind(this)), this._onLoadMoreInfinite(l), this._initFiltersHtml()
        }
        return p.prototype = _.assignIn({}, p.prototype, {
            _initFiltersHtml: function() {
                $(".shop__filtering-inner").empty().append($(".site-sidebar").html())
            },
            _onFilterClear: function(e) {
                var i = [];
                Shopify.queryParams[d] && (i = Shopify.queryParams[d].split("+"));
                var t = $(e.currentTarget).closest(".site-widget.filtering"),
                    a = t.find("select");
                0 < a.length && a.find("option").each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = i.indexOf(e);
                        0 <= t && i.splice(t, 1)
                    }
                });
                var s = t.find("input");
                0 < s.length && s.each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = i.indexOf(e);
                        0 <= t && i.splice(t, 1)
                    }
                }), i.length ? Shopify.queryParams[d] = i.join("+") : delete Shopify.queryParams[d], this._filterAjaxClick(!0)
            },
            _onFilterChange: function(e) {
                var t = $(e.currentTarget),
                    i = t.closest(".advanced-filter"),
                    a = t.closest(".filter-tag"),
                    s = i.data("multi_choice"),
                    o = [];
                if (Shopify.queryParams[d] && (o = Shopify.queryParams[d].split("+")), 0 == s && !a.hasClass("active")) {
                    var n = i.find(".active input");
                    0 < n.length && n.each(function() {
                        var e = $(this).val();
                        if (e) {
                            var t = o.indexOf(e);
                            0 <= t && o.splice(t, 1)
                        }
                    })
                }
                var r = i.find("select");
                0 < r.length && r.find("option").each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = o.indexOf(e);
                        0 <= t && o.splice(t, 1)
                    }
                });
                var c = t.val();
                if (c) {
                    var l = o.indexOf(c);
                    0 <= l ? o.splice(l, 1) : o.push(c)
                }
                o.length ? Shopify.queryParams[d] = o.join("+") : delete Shopify.queryParams[d], this._filterAjaxClick(!0)
            },
            _onViewClick: function(e) {
                e.preventDefault();
                var t = $(e.currentTarget),
                    i = $(r),
                    a = t.data("view");
                "grid" == a && (a = a + "-" + t.data("per_row")), Shopify.queryParams[s] = a, this._filterAjaxClick(), i.removeClass("active"), t.addClass("active"), setTimeout(function() {
                    var e = $("#site-primary .products");
                    "list" == a ? (e.removeClass("products-grid"), e.addClass("products-list")) : (e.removeClass("products-list"), e.addClass("products-grid"))
                }, 250)
            },
            _onLoadMoreInfinite: function(e) {
                if ($(e).closest(".ajax_load_button").hasClass("ajax_load_hidden")) {
                    var t = "#site-primary .products",
                        i = Math.abs(0);
                    $(window).scroll(function() {
                        $(t).length && ($(t).offset().top + $(t).outerHeight() - $(window).scrollTop() - i < $(window).height() && 0 == $(e).attr("data-processing") && $(e).trigger("click"))
                    })
                }
            },
            _onLoadMoreClick: function(e) {
                e.preventDefault();
                var t = "#site-pagination button.btn",
                    i = "#site-pagination .ajax_load_button",
                    a = "#site-primary .products .product",
                    s = "#site-pagination";
                if ($(a).addClass("ajax_load_visible"), $(s).find("a.next").length) {
                    $(t).attr("data-processing", 1);
                    var o = $(s).find("a.next").attr("href"),
                        n = $(t).attr("data-loading-items"),
                        r = $(t).attr("data-no-more");
                    $(i).hide(), $(i).after('<div class="ajax_load_loader animated fadeIn"><span class="btn">' + n + "</span></div>"), $.get(o, function(e) {
                        $(s).empty().html($(e).find(s).html()), $(e).find(a).each(function() {
                            $(this).addClass("hidden"), $(a).last().after($(this))
                        }), $(".ajax_load_loader").hide(), $(i).fadeIn("slow"), $(t).attr("data-processing", 0), setTimeout(function() {
                            $(a).not(".ajax_load_visible").addClass("animated fadeIn").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                                $(this).removeClass("hidden animated fadeIn").addClass("ajax_load_visible")
                            })
                        }, 500), 0 == $(s).find("a.next").length && ($(i).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(t).show().html(r).addClass("disabled").prop("disabled", !0))
                    })
                } else {
                    r = $(t).attr("data-no-more");
                    $(i).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(t).show().html(r).addClass("disabled").prop("disabled", !0)
                }
            },
            _onPageClick: function(e) {
                e.preventDefault();
                var t = $(e.currentTarget).attr("href");
                this._filterGetContent(t)
            },
            _onSortChange: function(e) {
                var t = this.$sortSelect.val() || this.defaultSort;
                Shopify.queryParams[i] = t, this._filterAjaxClick(), this._resizeSelect($(e.target))
            },
            _onLimitChange: function(e) {
                var t = this.$limitSelect.val() || this.defaultLimit;
                Shopify.queryParams[a] = t, this._filterAjaxClick(), this._resizeSelect($(e.target))
            },
            _getDefaultLimitValue: function() {
                return $(e, this.$container).val()
            },
            _getDefaultSortValue: function() {
                return $(t, this.$container).val()
            },
            _resizeSelect: function(e) {
                e.each(function() {
                    var e = $(this),
                        t = e.find("option:selected").text(),
                        i = $("<span>").html(t);
                    i.appendTo("body");
                    var a = i.width();
                    i.remove(), e.width(a + 3)
                })
            },
            _filterAjaxClick: function(e) {
                void 0 === e && (e = !1), delete Shopify.queryParams.page;
                var t = this._filterCreateUrl();
                this._filterGetContent(t, e)
            },
            _filterCreateUrl: function() {
                var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                return location.pathname + "?" + e
            },
            _filterGetContent: function(i, a) {
                void 0 === a && (a = !1);
                var s = "#site-primary .products",
                    o = "#site-primary .products .product",
                    n = "#site-pagination",
                    r = "#site-secondary";
                $(o).addClass("ajax_load_visible"), $.ajax({
                    type: "GET",
                    url: i,
                    beforeSend: function() {
                        $("body").addClass("loading")
                    },
                    complete: function() {
                        $("body").removeClass("loading")
                    },
                    success: function(e) {
                        $.fn.countdown && $(s).find(".product__countdown .is-countdown").each(function() {
                            $(this).countdown("destroy")
                        }), $(n).empty().html($(e).find(n).html()), a && $(r).empty().html($(e).find(r).html()), $(s).empty(), 0 < $(e).find(o).length ? ($(e).find(o).each(function() {
                            $(this).addClass("hidden"), $(s).append($(this))
                        }), setTimeout(function() {
                            $(o).not(".ajax_load_visible").addClass("animated fadeIn").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                                $(this).removeClass("hidden animated fadeIn").addClass("ajax_load_visible")
                            })
                        }, 200)) : $(s).append($(e).find("#site-primary .no-products"));
                        var t = $(e).filter("title").text();
                        History.pushState({
                            param: Shopify.queryParams
                        }, t, i), setTimeout(function() {
                            $("html, body").animate({
                                scrollTop: $("#site-primary").offset().top
                            }, 500, "swing")
                        }, 100)
                    }
                })
            },
            onUnload: function() {
                this.$limitSelect.off("change", this._onLimitChange), this.$sortSelect.off("change", this._onSortChange), $(document).off("click", r, this._onViewClick), $(document).off("click", c, this._onPageClick), $(document).off("click", l, this._onLoadMoreClick)
            }
        }), p
    }(), window.theme = window.theme || {}, theme.HeaderMobile = function() {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id");
            this.selectors = {
                searchOpenIcon: ".mobile-search__open",
                searchCloseIcon: ".mobile-search__close",
                searchWrapper: ".mobile-header__search .search__dropdown",
                navOpenIcon: ".mobile-nav__open",
                navCloseIcon: ".mobile-nav__close",
                navWrapper: ".mobile-header__nav .mobile__menu"
            }, this.initSearch(), this.initMenu()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            initSearch: function() {
                var a = this.selectors;
                $(document).on("click", a.searchOpenIcon, function(e) {
                    e.preventDefault();
                    var t = $(this).closest(".mobile-header__search");
                    t.addClass("search-opened"), setTimeout(function() {
                        t.find(".search__input").focus().select()
                    }, 300)
                }), $(document).on("click", a.searchCloseIcon, function(e) {
                    e.preventDefault(), $(this).closest(".mobile-header__search").removeClass("search-opened")
                }), $(document).on("touchstart", function(e) {
                    var t = $(a.searchWrapper);
                    if (!t.is(e.target) && 0 === t.has(e.target).length) {
                        var i = t.closest(".mobile-header__search");
                        i.hasClass("search-opened") && i.removeClass("search-opened")
                    }
                })
            },
            initMenu: function() {
                var e = this.selectors;
                $(e.navWrapper).length && $(e.navWrapper).mmenu(), $(document).on("click", e.navOpenIcon, function(e) {
                    e.preventDefault(), $(this).closest(".mobile-header__nav").addClass("menu-opened")
                }), $(document).on("click", e.navCloseIcon, function(e) {
                    e.preventDefault(), $(this).closest(".mobile-header__nav").removeClass("menu-opened")
                })
            },
            onUnload: function() {}
        }), e
    }(), theme.HeaderSection = function() {
        function e() {
            theme.Search.init(), theme.CurrencyPicker.init(), theme.LanguagePicker.init(), theme.MiniCart.init();
            var e = new theme.Sections;
            e.register("mega-menu", theme.MegaMenu), e.register("vertical-menu", theme.VerticalMenu)
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {}
        }), e
    }(), theme.MegaMenu = function() {
        function e() {
            this.init(), this.sticky()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var t, i = ".site-phantom-menu .site-navigation",
                    e = ".site-header-menu",
                    a = ".site-header-menu-left",
                    s = ".site-header-menu-right";
                ($(i).length && $(e).length && $(e).each(function() {
                    var e = $(i).clone();
                    $(this).empty().append(e)
                }), $(i).length && $(a).length) && ((t = $(i).clone()).find(".site-nav__items > .site-nav__item").each(function() {
                    $(this).hasClass("pull-right") && $(this).remove()
                }), $(a).each(function() {
                    var e = t.clone();
                    $(this).empty().append(e)
                }));
                $(i).length && $(s).length && ((t = $(i).clone()).find(".site-nav__items > .site-nav__item").each(function() {
                    $(this).hasClass("pull-right") || $(this).remove()
                }), $(s).each(function() {
                    var e = t.clone();
                    $(this).empty().append(e)
                }))
            },
            sticky: function() {
                var t = ".header-sticky__placeholder",
                    i = ".site-header__main";
                $(t).length && $(window).scroll(function() {
                    var e = $(this).scrollTop();
                    $(this).height();
                    $(i).is(":visible") && (e < $(i).offset().top + $(i).outerHeight() + $(".site-header__bottom").outerHeight() + 50 ? $(t).removeClass("visible") : ($(t).addClass("visible"), $(".site-header:not(.header-sticky) .minicart").removeClass("opened")))
                })
            },
            onUnload: function() {}
        }), e
    }(), theme.VerticalMenu = function() {
        function e() {
            this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var t = ".site-phantom-menu-vertical .site-nav__vertical",
                    e = ".site-header-menu-vertical";
                $(t).length && $(e).length && $(e).each(function() {
                    var e = $(t).clone();
                    $(this).empty().append(e)
                })
            },
            onUnload: function() {}
        }), e
    }(), theme.Maps = function() {
        var o = 14,
            t = null,
            s = [],
            n = {
                addressNoResults: theme.strings.addressNoResults,
                addressQueryLimit: theme.strings.addressQueryLimit,
                addressError: theme.strings.addressError,
                authError: theme.strings.authError
            },
            e = '[data-section-type="map"]',
            r = "[data-map]",
            i = "[data-map-overlay]",
            c = "map-section--load-error",
            l = "map-section__error errors text-center";

        function a(e) {
            var i, a;
            (this.$container = $(e), this.$map = this.$container.find(r), this.key = this.$map.data("api-key"), void 0 !== this.key) && ("loaded" === t ? this.createMap() : (s.push(this), "loading" !== t && (t = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function() {
                t = "loaded", $.each(s, function(e, t) {
                    t.createMap()
                })
            }))), i = $("body"), a = $(".page-contact .contact-section"), $(document).on("click", ".page-contact .btn-contact", function() {
                $(".page-contact .contact-section").toggleClass("opened"), i.toggleClass("contact-opened")
            }), $(document).mouseup(function(e) {
                var t = $(".page-contact .contact-section .container");
                t.is(e.target) || 0 !== t.has(e.target).length || a.hasClass("opened") && (a.addClass("closed"), setTimeout(function() {
                    a.removeClass("opened").removeClass("closed"), i.removeClass("contact-opened")
                }, 250))
            }), $(document).keyup(function(e) {
                "27" == e.which && a.hasClass("opened") && (a.addClass("closed"), setTimeout(function() {
                    a.removeClass("opened").removeClass("closed"), i.removeClass("contact-opened")
                }, 250))
            }))
        }
        return window.gm_authFailure = function() {
            Shopify.designMode && ($(e).addClass(c), $(r).remove(), $(i).after('<div class="' + l + '">' + theme.strings.authError + "</div>"))
        }, a.prototype = _.assignIn({}, a.prototype, {
            createMap: function() {
                var e, i, t, a, s = this.$map;
                return (e = s, i = $.Deferred(), t = new google.maps.Geocoder, a = e.data("address-setting"), t.geocode({
                    address: a
                }, function(e, t) {
                    t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e)
                }), i).then(function(e) {
                    var t = {
                            zoom: o,
                            center: e[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        i = this.map = new google.maps.Map(s[0], t),
                        a = this.center = i.getCenter();
                    new google.maps.Marker({
                        map: i,
                        position: i.getCenter()
                    });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(i, "resize"), i.setCenter(a), s.removeAttr("style")
                    }))
                }.bind(this)).fail(function() {
                    var e;
                    switch (status) {
                        case "ZERO_RESULTS":
                            e = n.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            e = n.addressQueryLimit;
                            break;
                        case "REQUEST_DENIED":
                            e = n.authError;
                            break;
                        default:
                            e = n.addressError
                    }
                    Shopify.designMode && s.parent().addClass(c).html('<div class="' + l + '">' + e + "</div>")
                })
            },
            onUnload: function() {
                0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize")
            }
        }), a
    }(), theme.Product = function() {
        function e(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                enableHistoryState: t.data("enable-history-state") || !1,
                namespace: ".ProductSection-" + i,
                sectionId: i,
                sectionType: t.data("section-type"),
                zoomEnabled: !1,
                sliderThumbsActive: !1,
                sliderImagesActive: !1,
                videoElement: !1,
                swatchColor: t.data("product_swatch_color"),
                swatchColorAdvanced: t.data("product_swatch_color_advanced"),
                swatchSize: t.data("product_swatch_size")
            }, this.selectors = {
                inComing: "#InComing-" + i,
                addToCart: "#AddToCart-" + i,
                addToCartText: "#AddToCartText-" + i,
                comparePrice: "#ComparePrice-" + i,
                originalPrice: "#ProductPrice-" + i,
                SKU: ".product-single__sku",
                originalSelectorId: "#ProductSelect-" + i,
                productImage: "#ProductImage-" + i,
                productImages: ".product-single__photos-" + i,
                productImageWraps: ".product-single__photo",
                productPrices: ".product-single__price-" + i,
                productThumbImages: ".product-single__thumbnail--" + i,
                productThumbs: ".product-single__thumbnails-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                singleOptionSelectorId: "#single-option-selector-" + i,
                singleOptionSwatches: "tawcvs-swatches-" + i,
                sizeChart: ".sizechart_btn",
                productContent: ".product-single__content",
                productQuantity: ".product-form__item--quantity",
                productTabs: ".product-single__tabs",
                productReviews: ".product-single__review",
                photoSwipeTrigger: ".product-single__show-gallary",
                recentlyViewed: ".recently-viewed-" + i,
                cartAgree: "#product-cart__agree-" + i,
                cartCheckout: "#product-buy__1click-" + i,
                stockCountdown: "#product-single__stock-" + i,
                visitorCounter: "#product-single__visitor-" + i,
                totalSold: "#product-single__sold-" + i
            }, $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.productSwatchSingleObject = JSON.parse(document.getElementById("ProductSwatchJson-" + i).innerHTML), this.productMoreSingleObject = JSON.parse(document.getElementById("ProductMoreJson-" + i).innerHTML), this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("js-zoom-enabled"), this._updateProductObject(), this._initBreakpoints(), this._initVariants(), this._initSwatches(), this._initImageSwitch(), this._initGalleryZoom(), this._initTabs(), this._initReviews(), this._initQuantity(), this._stickyDetails(), this._recordRecentlyViewed(), this._showRecentlyViewed(), this._sizeChart(), this._checkoutCart(), this._initStockCountdown(), this._visitorCounter(), this._totalSold())
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initBreakpoints: function() {
                var e = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.sliderImagesActive && e._destroyImageSlider(), e._initImageSlider(), e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider(), e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            $(this).trigger("zoom.destroy")
                        })
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.sliderImagesActive && e._destroyImageSlider(), e._initImageSlider(!1), e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider(!1), e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            var e, t;
                            e = this, t = $(e).data("zoom"), $(e).zoom({
                                url: t,
                                onZoomIn: function() {
                                    $(this).addClass("active")
                                },
                                onZoomOut: function() {
                                    $(this).removeClass("active")
                                }
                            })
                        })
                    }
                })
            },
            _updateProductObject: function() {
                var a = this;
                $.each(a.productMoreSingleObject.variants, function(i, e) {
                    $.each(e, function(e, t) {
                        a.productSingleObject.variants[i][e] = t
                    })
                })
            },
            _totalSold: function() {
                if ($(this.selectors.totalSold).length) {
                    var e = $(this.selectors.totalSold),
                        t = e.data("qty_min"),
                        i = e.data("qty_max"),
                        a = e.data("time_min"),
                        s = e.data("time_max");
                    t = Math.ceil(t), i = Math.floor(i), a = Math.ceil(a), s = Math.floor(s);
                    var o = Math.floor(Math.random() * (i - t + 1)) + t;
                    (o = parseInt(o)) <= t && (o = t), i < o && (o = i), e.html(e.html().replace("/count/", o));
                    var n = Math.floor(Math.random() * (s - a + 1)) + a;
                    (n = parseInt(n)) <= a && (n = a), s < n && (n = s), e.html(e.html().replace("/time/", n)), e.show(), e.find("img").first().length && setInterval(function() {
                        e.find("img").first().fadeIn(function() {
                            $(this).css("visibility", "visible")
                        }).delay(400).fadeIn(function() {
                            $(this).css("visibility", "hidden")
                        }).delay(600)
                    }, 1e3)
                }
            },
            _visitorCounter: function() {
                if ($(this.selectors.visitorCounter).length) {
                    var e = $(this.selectors.visitorCounter),
                        t = e.data("max"),
                        i = e.data("interval"),
                        a = 1,
                        s = t;
                    a = Math.ceil(a), s = Math.floor(s);
                    var o = Math.floor(Math.random() * (s - a + 1)) + a,
                        n = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
                        r = "",
                        c = "",
                        l = ["10", "20", "15"],
                        d = (r = "", c = "", "");
                    setInterval(function() {
                        (r = Math.floor(Math.random() * n.length), c = n[r], (o = parseInt(o) + parseInt(c)) <= 1) && (d = Math.floor(Math.random() * l.length), o += l[d]);
                        (o < 1 || t < o) && (o = Math.floor(Math.random() * (s - a + 1)) + a), e.find("strong").first().text(parseInt(o)), e.show()
                    }, 1e3 * i)
                }
            },
            _initStockCountdown: function() {
                if ($(this.selectors.stockCountdown).length) {
                    var t = $(this.selectors.stockCountdown);
                    if (t.hasClass("is-fake")) {
                        var i = 60,
                            e = t.data("min"),
                            a = t.data("max"),
                            s = d(e, a),
                            o = null,
                            n = null,
                            r = 1,
                            c = 1.7,
                            l = 3;

                        function d(e, t) {
                            return Math.floor(Math.random() * (t - e + 1) + e)
                        }

                        function u() {
                            var e = 100 * s / i;
                            t.find(".progress-bar span").css("width", e + "%")
                        }
                        t.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", s)), o = setTimeout(function() {
                            --s < r && (s = d(e, a)), t.find(".stock-countdown-message strong").text(s), u(), s < e && clearTimeout(o)
                        }, 1e3 * l), n = setInterval(function() {
                            --s < r && (s = d(e, a)), t.find(".stock-countdown-message strong").text(s), u(), s < e && clearInterval(n)
                        }, 6e4 * c), t.hasClass("is-visible") && t.removeClass("hide")
                    }
                }
            },
            _updateStockCountdown: function(e) {
                var t = $(this.selectors.stockCountdown);
                t.hasClass("is-fake") ? t.removeClass("hide") : (t.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", e)), t.find(".progress-bar span").first().css("width", "100%"), t.removeClass("hide"), setTimeout(function() {
                    t.find(".progress-bar span").first().css("width", "28%")
                }, 500))
            },
            _checkoutCart: function() {
                var a = this;
                $(document).on("DOMNodeInserted", a.selectors.cartCheckout, function() {
                    var t = $(this);
                    setTimeout(function() {
                        var e = t.find(".shopify-payment-button__button");
                        e.length && (t.hide(), setTimeout(function() {
                            $(a.selectors.cartAgree).is(":checked") ? e.removeClass("btn-disabled") : e.addClass("btn-disabled"), t.fadeIn()
                        }, 300))
                    }, 0)
                }), $(document).on("change", a.selectors.cartAgree, function(e) {
                    var t = $(this),
                        i = $(a.selectors.cartCheckout).find(".shopify-payment-button__button");
                    t.is(":checked") ? i.removeClass("btn-disabled") : i.addClass("btn-disabled")
                })
            },
            _pauseVideo: function(e) {
                if (!$(this.selectors.productThumbImages + "[data-thumbnail_id='" + e + "']", this.$container).hasClass("video")) {
                    var t = $(this.selectors.productThumbImages + ".video", this.$container).data("thumbnail_id"),
                        i = $(this.selectors.productImageWraps + "[data-image_id='" + t + "']", this.$container).find("video")[0];
                    i && i.played && (i.pause(), i.load())
                }
            },
            _playVideo: function(e) {
                var t = $(this.selectors.productThumbImages + "[data-thumbnail_id='" + e + "']", this.$container);
                if (t.hasClass("video")) {
                    var i = this,
                        a = $(this.selectors.productImageWraps + "[data-image_id='" + e + "']", this.$container).find("video")[0];
                    if (a) {
                        a.play();
                        var s = 1;
                        a.addEventListener("ended", function() {
                            if (s < 2) a.play(), s++;
                            else {
                                var e = t.data("thumbnail_prev");
                                $(i.selectors.productThumbImages + "[data-thumbnail_id='" + e + "']")[0].click()
                            }
                        }, !1)
                    }
                }
            },
            _beforeInitSlider: function(e) {
                var t = this;
                void 0 === e && (e = !0), 0 == e ? $(this.selectors.productImages + " .product-single__photo-container").each(function() {
                    var e = $(this);
                    e.hasClass("video") && (t.settings.videoElement = e.clone(), e.remove())
                }) : t.settings.videoElement && ($(this.selectors.productImages).append(t.settings.videoElement), t.settings.videoElement = !1)
            },
            _initImageSlider: function(e) {
                void 0 === e && (e = !0);
                var t = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: !1,
                    fade: !0,
                    cssEase: "linear",
                    asNavFor: this.selectors.productThumbs
                };
                1 == $(this.selectors.productImages).data("center_mode") && (0 == e ? (t = {
                    rtl: theme.settings.rtl,
                    centerMode: !0,
                    centerPadding: "20%",
                    slidesToShow: 1,
                    asNavFor: this.selectors.productThumbs
                }, this._beforeInitSlider(!1)) : this._beforeInitSlider()), this.settings.sliderImagesActive = !0, $(this.selectors.productImages).slick(t)
            },
            _initThumbnailSlider: function(e) {
                void 0 === e && (e = !0);
                var t = !1;
                0 == e && 1 == $(this.selectors.productThumbs).data("vertical") && (t = !0);
                var i = {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    vertical: t,
                    verticalSwiping: t,
                    asNavFor: this.selectors.productImages,
                    focusOnSelect: !0
                };
                this.settings.sliderThumbsActive = !0, $(this.selectors.productThumbs).slick(i), $(this.selectors.productImages).slick("slickGoTo", 0)
            },
            _destroyImageSlider: function() {
                $(this.selectors.productImages).slick("unslick"), this.settings.sliderImagesActive = !1
            },
            _destroyThumbnailSlider: function() {
                $(this.selectors.productThumbs).slick("unslick"), this.settings.sliderThumbsActive = !1
            },
            _initImageSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    $.fn.visible = function(e) {
                        var t = $(this),
                            i = $(window),
                            a = i.scrollTop(),
                            s = a + i.height(),
                            o = t.offset().top,
                            n = o + t.height();
                        return (!0 === e ? o : n) <= s && a <= (!0 === e ? n : o)
                    };
                    var r = this;
                    $(document).on("click", r.selectors.productThumbImages, function(e) {
                        e.preventDefault()
                    }), $(r.selectors.productThumbs).on("beforeChange", function(e, t, i, a) {
                        var s = $(r.selectors.productThumbs).find(".slick-slide").eq([a]);
                        if (s.find(".product-single__thumbnail").length) {
                            var o = s.find(".product-single__thumbnail"),
                                n = o.data("thumbnail_id");
                            o.hasClass("video") ? r._playVideo(n) : setTimeout(function() {
                                r._pauseVideo(n)
                            }, 500)
                        }
                    }), $(window).scroll(function(e) {
                        $(r.selectors.productImageWraps).each(function(e, t) {
                            var i = $(t);
                            i.visible(!0) && i.addClass("come-in")
                        })
                    })
                }
            },
            _switchImage: function(e) {
                "product-quickview" != this.settings.sectionType ? $(this.selectors.productThumbImages).length && $(this.selectors.productThumbImages + "[data-thumbnail_id='" + e.id + "']")[0].click() : $(this.selectors.productImage).attr("data-bgset", this._bgset(e)).removeClass("lazyloaded").addClass("lazyload")
            },
            _bgset: function(t) {
                if (t) {
                    var i = t.width / t.height,
                        a = "";
                    return [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450, 2700, 3e3, 3350, 3750, 4100].forEach(function(e) {
                        t.width > e && (a += theme.Images.getSizedImageUrl(t.src, e + "x") + " " + e + "w " + Math.round(e / i) + "h,")
                    }), a += theme.Images.getSizedImageUrl(t.src, "master") + " " + t.width + "w " + t.height + "h"
                }
            },
            _initGalleryZoom: function() {
                var i = this,
                    s = $(".pswp")[0];
                $(document).on("click", i.selectors.photoSwipeTrigger, function(e) {
                    e.preventDefault();
                    $(this).parent();
                    var a, t = {
                        index: $(this).data("index"),
                        bgOpacity: .7,
                        showHideOpacity: !0
                    };
                    new PhotoSwipe(s, PhotoSwipeUI_Default, (a = [], $(i.selectors.productImages + " .feature-row__image").each(function() {
                        var e = $(this).data("large_image"),
                            t = $(this).data("large_image_width"),
                            i = $(this).data("large_image_height");
                        a.push({
                            src: e,
                            w: t,
                            h: i,
                            title: !1
                        })
                    }), a), t).init()
                })
            },
            _initQuantity: function() {
                var i = this;

                function a(e) {
                    var t = 0;
                    $(e).closest(".product-single__content").find(i.selectors.productQuantity + " .quantity").each(function() {
                        t += $(this).val()
                    }), 0 < t ? $(i.selectors.addToCart).prop("disabled", !1) : $(i.selectors.addToCart).prop("disabled", !0)
                }
                $(document).off("click", i.selectors.productQuantity + " .plus"), $(document).on("click", i.selectors.productQuantity + " .plus", function() {
                    var e = $(this).closest(i.selectors.productQuantity).find(".quantity"),
                        t = parseInt(e.val());
                    t += 1, e.val(t), a(this)
                }), $(document).off("click", i.selectors.productQuantity + " .minus"), $(document).on("click", i.selectors.productQuantity + " .minus", function() {
                    var e = $(this).closest(i.selectors.productQuantity).find(".quantity"),
                        t = parseInt(e.val());
                    0 < t && (t -= 1, e.val(t), a(this))
                })
            },
            _stickyDetails: function() {
                var e = $(this.selectors.productContent);
                !e.data("sticky") || $(window).width() < 992 || e.each(function() {
                    var e = $(this).parent(),
                        t = 40,
                        i = $(this),
                        a = e.closest(".product-single").find(".product-single__photos");
                    $("body").hasClass("sticky-header") && (t = 150);
                    var s = i.outerHeight() - a.outerHeight();
                    s < -100 ? i.stick_in_parent({
                        offset_top: t
                    }) : 100 < s && a.stick_in_parent({
                        offset_top: t
                    }), $(window).resize(function() {
                        $(window).width() < 992 ? (i.trigger("sticky_kit:detach"), a.trigger("sticky_kit:detach")) : i.outerHeight() < a.outerHeight() ? i.stick_in_parent({
                            offset_top: t
                        }) : a.stick_in_parent({
                            offset_top: t
                        })
                    })
                })
            },
            _initTabs: function() {
                var o = $(this.selectors.productTabs),
                    n = ".product-tabs__title";
                (o.hasClass("tabs-layout-tabs") || o.hasClass("tabs-layout-accordion")) && $(document).on("click", n, function(e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.attr("href"),
                        a = $(n, o),
                        s = $(".product-tabs__panel", o);
                    $(".product-tabs", o).is(":visible") ? (a.removeClass("active"), s.removeClass("active"), t.addClass("active"), $(i).addClass("active")) : (t.hasClass("active") ? (t.removeClass("active"), $(i).removeClass("active")) : (a.removeClass("active"), s.removeClass("active"), t.addClass("active"), $(i).addClass("active")), s.each(function() {
                        $(this).hasClass("active") ? $(this).slideDown(250) : $(this).slideUp(250)
                    }))
                })
            },
            _initReviews: function() {
                if (!$(this.selectors.productTabs).length) return !1;
                var i = this.selectors.productTabs;
                $(document).on("click", this.selectors.productReviews, function() {
                    if ($(i).hasClass("tabs-layout-tabs") || $(i).hasClass("tabs-layout-accordion")) {
                        var e = $(i + " #tab-reviews").prev();
                        $(".product-tabs", i).is(":visible") && (e = $(i + " .reviews_tab .product-tabs__title")), e.hasClass("active") || e.trigger("click")
                    }
                    var t = $(i + " #tab-reviews").parent();
                    $(".product-tabs", i).is(":visible") && (t = $(i)), setTimeout(function() {
                        $("html, body").animate({
                            scrollTop: t.offset().top
                        }, 500, "swing")
                    }, 250)
                })
            },
            _initSwatches: function() {
                var c = this;
                var e, t, a, s, o, n, r = this.productSingleObject,
                    l = this.productSwatchSingleObject,
                    d = new Array;
                if ("1" == this.settings.swatchSize && d.push("Size"), d.push("size"), "1" == this.settings.swatchColor && (d.push("Color"), d.push("Colour"), d.push("color"), d.push("colour")), 0 < d.length) {
                    var u = !1,
                        h = 0,
                        p = theme.settings.assetUrl.substring(0, theme.settings.assetUrl.lastIndexOf("?")),
                        m = theme.settings.assetUrl.substring(theme.settings.assetUrl.lastIndexOf("?"), theme.settings.assetUrl.length);
                    for (i = 0; i < r.options.length; i++) {
                        var f = "",
                            g = "",
                            v = "",
                            _ = "",
                            y = "",
                            C = "",
                            w = "",
                            b = "img btooltip";
                        if (f = "object" == typeof r.options[i] ? r.options[i].name : r.options[i], u = !1, -1 < d.indexOf(f)) {
                            u = !0, h = i;
                            var k = f.toLowerCase();
                            if (/color|colour/i.test(k) && !0, u) {
                                var S = new Array;
                                for (j = 0; j < r.variants.length; j++) {
                                    var I = r.variants[j],
                                        T = (n = I.options[h], String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")),
                                        x = T.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    c.settings.sectionId;
                                    S.indexOf(T) < 0 && ("color" != k && "colour" != k ? (w = T, b = "btooltip") : "1" == this.settings.swatchColorAdvanced ? null !== l[x] && void 0 !== l[x] && "" != l[x] ? (b = "img btooltip swatch_color_advanced", w = '<i style="background-image: url(' + p + l[x] + ".png" + m + ')"></i>') : null !== I.featured_image ? (b = "img btooltip swatch_color_advanced", w = '<i style="background-image: url(' + (e = I.featured_image.src, a = t = void 0, t = e.replace("https:", "").replace("http:", "").split("?v=")[0].split("/"), a = t[t.length - 1].split("."), s = a.pop(), o = a.join(".") + "_100x." + s, e.replace(t[t.length - 1], o)) + ')"></i>') : w = '<i style="background-color:' + T + "; background-image: url(" + p + x + ".png" + m + ')"></i>' : w = '<i style="background-color:' + T + "; background-image: url(" + p + x + ".png" + m + ')"></i>', C = $(c.selectors.singleOptionSelectorId + "-" + h).val() == T ? "selected " : "", v = v + '<div class="swatch-element ' + k + x + ' available"><input data-id="' + c.selectors.singleOptionSelectorId + "-" + h + '" data-value="' + T + '" class="swatch-radio ' + C + '" id="swatch-' + c.settings.sectionId + "-" + h + "-" + x + '" type="radio" data-poption="' + h + '" name="option-' + h + '" value="' + T + '"><label for="swatch-' + c.settings.sectionId + "-" + h + "-" + x + '" class="' + b + '" title="' + T + '"><span class="soldout-image"></span>' + w + "</label></div>", S.push(T))
                                }
                                g = '<div class="' + c.selectors.singleOptionSwatches + " wrapper-swatches swatch " + k + '" data-attribute_name="attribute_pa_' + k + '">' + v + "</div>", _ = $(c.selectors.singleOptionSelectorId + "-" + h), y = $(c.selectors.variationSelector + "-" + h), "" != g && (_.after(g), _.hide(), y.addClass("hide-choose-option"))
                            }
                        }
                    }
                }
                var P = "",
                    A = "." + c.selectors.singleOptionSwatches + " .swatch-radio";
                0 < $("." + c.selectors.singleOptionSwatches).length && ((P = $(A)).unbind("click"), P.on("click", function() {
                    var e = $(this).data("id"),
                        t = $(this).data("poption"),
                        a = $(this).data("value");
                    $(this).data("value") != $(e).val() && ($(e).val($(this).data("value")).trigger("change"), $(e).closest(".selector-wrapper").find(".swatch-radio").removeClass("selected"), $(this).addClass("selected"), $(e).closest(".selector-wrapper"), $(e).closest(".selector-wrapper").find(".option-select-value").html($(this).data("value"))),
                        function(o, n, r) {
                            if (1 < o.options.length)
                                for (i = 0; i < o.options.length; i++) i != n && $(c.selectors.singleOptionSelectorId + "-" + i + " option").each(function() {
                                    var e = "unavailable",
                                        t = $(this).attr("value");
                                    for (j = 0; j < o.variants.length; j++) {
                                        var a = o.variants[j];
                                        if (a.options[n] == r && a.options[i] == t) {
                                            e = 1 == a.available ? "available" : "sold_out";
                                            break
                                        }
                                    }
                                    var s = "#swatch-" + c.settings.sectionId + "-" + i + "-" + t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    $(s).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(e)
                                });
                            else
                                for (i = 0; i < o.options.length; i++) $(c.selectors.singleOptionSelectorId + "-" + i + " option").each(function() {
                                    var e = "unavailable",
                                        t = $(this).attr("value");
                                    for (j = 0; j < o.variants.length; j++)
                                        if (o.variants[j].options[i] == t) {
                                            e = o.variants[j].available ? "available" : "sold_out";
                                            break
                                        } var a = "#swatch-" + c.settings.sectionId + "-" + i + "-" + t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    $(a).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(e)
                                })
                        }(r, t, a)
                })), $(".swatch-radio.selected").trigger("click")
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
                t ? ($(this.selectors.productPrices).removeClass("visibility-hidden"), t.available ? ($(this.selectors.addToCart).prop("disabled", !1), t.inventory_quantity <= 0 && "shopify" == t.inventory_management ? $(this.selectors.addToCartText).text(theme.strings.preOrder) : $(this.selectors.addToCartText).text(theme.strings.addToCart), $(this.selectors.productQuantity).removeClass("btn-disabled"), $(this.selectors.inComing).addClass("hide"), 0 < t.inventory_quantity && "shopify" == t.inventory_management ? this._updateStockCountdown(t.inventory_quantity) : $(this.selectors.stockCountdown).removeClass("hide"), $(this.selectors.totalSold).removeClass("hide")) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(this.selectors.productQuantity).addClass("btn-disabled"), t.incoming ? $(this.selectors.inComing).html(theme.strings.inComing.replace("{{ date }}", t.next_incoming_date)).removeClass("hide") : $(this.selectors.inComing).addClass("hide"), $(this.selectors.stockCountdown).addClass("hide"), $(this.selectors.totalSold).addClass("hide"))) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.productQuantity).addClass("btn-disabled"), $(this.selectors.productPrices).addClass("visibility-hidden"), $(this.selectors.inComing).addClass("hide"), $(this.selectors.stockCountdown).addClass("hide"), $(this.selectors.totalSold).addClass("hide"))
            },
            _updateImages: function(e) {
                var t = e.variant;
                this._switchImage(t.featured_image)
            },
            _updatePrice: function(e) {
                var t = e.variant;
                $(this.selectors.originalPrice).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.settings.moneyFormat) + "</span>"), t.compare_at_price > t.price ? $(this.selectors.comparePrice).html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat) + "</span>").removeClass("hide") : $(this.selectors.comparePrice).addClass("hide"), theme.CurrencyPicker.convert(this.selectors.productPrices + " .money")
            },
            _updateSKU: function(e) {
                var t = e.variant;
                $(this.selectors.SKU).html(t.sku)
            },
            _recordRecentlyViewed: function() {
                var e = [],
                    t = localStorage.getItem("roarStorage_recentlyViewed");
                null !== t && (e = (e = t.split(",")).filter(function(e) {
                    return e.replace(/(\r\n|\n|\r)/gm, "")
                }));
                var i = this.productSingleObject.handle,
                    a = $.inArray(i, e); - 1 == a ? (e.unshift(i), e = e.splice(0, 180)) : (e.splice(a, 1), e.unshift(i)), localStorage.setItem("roarStorage_recentlyViewed", e.join(","))
            },
            _showRecentlyViewed: function() {
                var t = this,
                    i = [],
                    e = localStorage.getItem("roarStorage_recentlyViewed");
                null !== e && (i = (i = e.split(",")).filter(function(e) {
                    return e.replace(/(\r\n|\n|\r)/gm, "")
                }));
                var a = t.productSingleObject.handle,
                    s = $.inArray(a, i); - 1 != s && i.splice(s, 1);
                var o = $(t.selectors.recentlyViewed + " .slick-slider");
                if (Math.min(i.length, 180) && o.length) {
                    var n = o.closest(".products-slider"),
                        r = {},
                        c = o.data("grid_num"),
                        l = o.data("grid_row"),
                        d = o.data("max_pages"),
                        u = 1,
                        h = i.splice(0, c * l * u),
                        p = {
                            rtl: theme.settings.rtl,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: !1,
                            infinite: !0
                        };
                    o.slick(p), $.ajax({
                        url: "/search",
                        data: {
                            view: "viewed",
                            page: u,
                            limit: c + "*" + l,
                            q: h.join(",")
                        },
                        dataType: "html",
                        type: "GET",
                        beforeSend: function() {
                            n.addClass("loading")
                        },
                        complete: function() {
                            n.removeClass("loading")
                        },
                        success: function(e) {
                            $(e).find(".product").length ? ($(t.selectors.recentlyViewed).removeClass("hide"), o.slick("slickAdd", e), 0 == i.length && n.addClass("finished")) : n.addClass("finished")
                        }
                    }), n.find(".slick-prev").off("click").on("click", function(e) {
                        e.preventDefault(), o.slick("slickPrev")
                    }), n.find(".slick-next").off("click").on("click", function(e) {
                        e.preventDefault(), (u = o.slick("slickCurrentSlide") + 1) < d ? r[u] ? o.slick("slickNext") : n.hasClass("loading") || n.hasClass("finished") || (h = i.splice(0, c * l * u), $.ajax({
                            url: "/search",
                            data: {
                                view: "viewed",
                                page: u,
                                limit: c + "*" + l,
                                q: h.join(",")
                            },
                            dataType: "html",
                            type: "GET",
                            beforeSend: function() {
                                n.addClass("loading")
                            },
                            complete: function() {
                                n.removeClass("loading")
                            },
                            success: function(e) {
                                $(e).find(".product").length ? (o.slick("slickAdd", e), o.slick("slickNext"), r[u] = !0, 0 == i.length && n.addClass("finished")) : n.addClass("finished")
                            }
                        })) : o.slick("slickNext")
                    })
                }
            },
            _sizeChart: function() {
                var i = $("body"),
                    a = $(this.selectors.sizeChart).next();
                $(document).on("click", this.selectors.sizeChart, function(e) {
                    e.preventDefault(), a.addClass("opened"), i.addClass("sizechart-opened")
                }), $(document).mouseup(function(e) {
                    var t = a.find(".container");
                    t.is(e.target) || 0 !== t.has(e.target).length || a.hasClass("opened") && (a.addClass("closed"), setTimeout(function() {
                        a.removeClass("opened").removeClass("closed"), i.removeClass("sizechart-opened")
                    }, 250))
                }), $(document).keyup(function(e) {
                    "27" == e.which && a.hasClass("opened") && (a.addClass("closed"), setTimeout(function() {
                        a.removeClass("opened").removeClass("closed"), i.removeClass("sizechart-opened")
                    }, 250))
                })
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.LineItem = function() {
        function e(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.settings = {
                enableHistoryState: !1,
                namespace: ".ProductSection-" + i,
                sectionId: i,
                swatchColor: !0,
                swatchColorAdvanced: !0,
                swatchSize: !0
            }, this.selectors = {
                productImage: "#ProductImage-" + i,
                addToCart: "#AddToCart-" + i,
                addToCartText: "#AddToCartText-" + i,
                comparePrice: "#ComparePrice-" + i,
                originalPrice: "#ProductPrice-" + i,
                productPrices: ".product-single__price-" + i,
                originalSelectorId: "#ProductSelect-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                singleOptionSelectorId: "#single-option-selector-" + i,
                singleOptionSwatches: "tawcvs-swatches-" + i
            }, $("#ProductJson-" + i).html() && (t.attr("enable-section-state") || (t.attr("enable-section-state", !0), this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.productSwatchSingleObject = JSON.parse(document.getElementById("ProductSwatchJson-" + i).innerHTML), this.productMoreSingleObject = JSON.parse(document.getElementById("ProductMoreJson-" + i).innerHTML), this._updateProductObject(), this._initVariants(), this._initSwatches()))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _updateProductObject: function() {
                var a = this;
                $.each(a.productMoreSingleObject.variants, function(i, e) {
                    $.each(e, function(e, t) {
                        a.productSingleObject.variants[i][e] = t
                    })
                })
            },
            _initSwatches: function() {
                var c = this;
                var e, t, a, s, o, n, r = this.productSingleObject,
                    l = this.productSwatchSingleObject,
                    d = new Array;
                if ("1" == this.settings.swatchSize && d.push("Size"), d.push("size"), "1" == this.settings.swatchColor && (d.push("Color"), d.push("Colour"), d.push("color"), d.push("colour")), 0 < d.length) {
                    var u = !1,
                        h = 0,
                        p = theme.settings.assetUrl.substring(0, theme.settings.assetUrl.lastIndexOf("?")),
                        m = theme.settings.assetUrl.substring(theme.settings.assetUrl.lastIndexOf("?"), theme.settings.assetUrl.length);
                    for (i = 0; i < r.options.length; i++) {
                        var f = "",
                            g = "",
                            v = "",
                            _ = "",
                            y = "",
                            C = "",
                            w = "",
                            b = "img btooltip";
                        if (f = "object" == typeof r.options[i] ? r.options[i].name : r.options[i], u = !1, -1 < d.indexOf(f)) {
                            u = !0, h = i;
                            var k = f.toLowerCase();
                            if (/color|colour/i.test(k) && !0, u) {
                                var S = new Array;
                                for (j = 0; j < r.variants.length; j++) {
                                    var I = r.variants[j],
                                        T = (n = I.options[h], String(n).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")),
                                        x = T.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    c.settings.sectionId;
                                    S.indexOf(T) < 0 && ("color" != k && "colour" != k ? (w = T, b = "btooltip") : "1" == this.settings.swatchColorAdvanced ? null !== l[x] && void 0 !== l[x] && "" != l[x] ? (b = "img btooltip swatch_color_advanced", w = '<i style="background-image: url(' + p + l[x] + ".png" + m + ')"></i>') : null !== I.featured_image ? (b = "img btooltip swatch_color_advanced", w = '<i style="background-image: url(' + (e = I.featured_image.src, a = t = void 0, t = e.replace("https:", "").replace("http:", "").split("?v=")[0].split("/"), a = t[t.length - 1].split("."), s = a.pop(), o = a.join(".") + "_100x." + s, e.replace(t[t.length - 1], o)) + ')"></i>') : w = '<i style="background-color:' + T + "; background-image: url(" + p + x + ".png" + m + ')"></i>' : w = '<i style="background-color:' + T + "; background-image: url(" + p + x + ".png" + m + ')"></i>', C = $(c.selectors.singleOptionSelectorId + "-" + h).val() == T ? "selected " : "", v = v + '<div class="swatch-element ' + k + x + ' available"><input data-id="' + c.selectors.singleOptionSelectorId + "-" + h + '" data-value="' + T + '" class="swatch-radio ' + C + '" id="swatch-' + c.settings.sectionId + "-" + h + "-" + x + '" type="radio" data-poption="' + h + '" name="option-' + h + '" value="' + T + '"><label for="swatch-' + c.settings.sectionId + "-" + h + "-" + x + '" class="' + b + '" title="' + T + '"><span class="soldout-image"></span>' + w + "</label></div>", S.push(T))
                                }
                                g = '<div class="' + c.selectors.singleOptionSwatches + " wrapper-swatches swatch " + k + '" data-attribute_name="attribute_pa_' + k + '">' + v + "</div>", _ = $(c.selectors.singleOptionSelectorId + "-" + h), y = $(c.selectors.variationSelector + "-" + h), "" != g && (_.after(g), _.hide(), y.addClass("hide-choose-option"))
                            }
                        }
                    }
                }
                var P = "",
                    A = "." + c.selectors.singleOptionSwatches + " .swatch-radio";
                0 < $("." + c.selectors.singleOptionSwatches).length && ((P = $(A)).unbind("click"), P.on("click", function() {
                    var e = $(this).data("id"),
                        t = $(this).data("poption"),
                        a = $(this).data("value");
                    $(this).data("value") != $(e).val() && ($(e).val($(this).data("value")).trigger("change"), $(e).closest(".selector-wrapper").find(".swatch-radio").removeClass("selected"), $(this).addClass("selected"), $(e).closest(".selector-wrapper"), $(e).closest(".selector-wrapper").find(".option-select-value").html($(this).data("value"))),
                        function(o, n, r) {
                            if (1 < o.options.length)
                                for (i = 0; i < o.options.length; i++) i != n && $(c.selectors.singleOptionSelectorId + "-" + i + " option").each(function() {
                                    var e = "unavailable",
                                        t = $(this).attr("value");
                                    for (j = 0; j < o.variants.length; j++) {
                                        var a = o.variants[j];
                                        if (a.options[n] == r && a.options[i] == t) {
                                            e = 1 == a.available ? "available" : "sold_out";
                                            break
                                        }
                                    }
                                    var s = "#swatch-" + c.settings.sectionId + "-" + i + "-" + t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    $(s).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(e)
                                });
                            else
                                for (i = 0; i < o.options.length; i++) $(c.selectors.singleOptionSelectorId + "-" + i + " option").each(function() {
                                    var e = "unavailable",
                                        t = $(this).attr("value");
                                    for (j = 0; j < o.variants.length; j++)
                                        if (o.variants[j].options[i] == t) {
                                            e = o.variants[j].available ? "available" : "sold_out";
                                            break
                                        } var a = "#swatch-" + c.settings.sectionId + "-" + i + "-" + t.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                                    $(a).closest(".swatch-element").removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(e)
                                })
                        }(r, t, a)
                })), $(".swatch-radio.selected").trigger("click")
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this))
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
                t ? ($(this.selectors.productPrices).removeClass("visibility-hidden"), t.available ? ($(this.selectors.addToCart).prop("disabled", !1), t.inventory_quantity <= 0 && "shopify" == t.inventory_management ? $(this.selectors.addToCartText).text(theme.strings.preOrder) : $(this.selectors.addToCartText).text(theme.strings.addToCart)) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut))) : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.productPrices).addClass("visibility-hidden"))
            },
            _updateImages: function(e) {
                var t = e.variant;
                this._switchImage(t.featured_image)
            },
            _updatePrice: function(e) {
                var t = e.variant;
                $(this.selectors.originalPrice).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.settings.moneyFormat) + "</span>"), t.compare_at_price > t.price ? $(this.selectors.comparePrice).html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat) + "</span>").removeClass("hide") : $(this.selectors.comparePrice).addClass("hide"), theme.CurrencyPicker.convert(this.selectors.productPrices + " .money")
            },
            _switchImage: function(e) {
                $(this.selectors.productImage).attr("data-bgset", this._bgset(e)).removeClass("lazyloaded").addClass("lazyload")
            },
            _bgset: function(t) {
                if (t) {
                    var i = t.width / t.height,
                        a = "";
                    return [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450, 2700, 3e3, 3350, 3750, 4100].forEach(function(e) {
                        t.width > e && (a += theme.Images.getSizedImageUrl(t.src, e + "x") + " " + e + "w " + Math.round(e / i) + "h,")
                    }), a += theme.Images.getSizedImageUrl(t.src, "master") + " " + t.width + "w " + t.height + "h"
                }
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.Quotes = function() {
        var c = {
                mediaQuerySmall: "screen and (max-width: 767px)",
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                slideCount: 0
            },
            l = {
                centerMode: !0,
                centerPadding: "25%",
                slidesToShow: 1
            };

        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id"),
                i = this.wrapper = ".quotes-wrapper",
                a = this.slider = "#Quotes-" + t,
                s = $(a, i),
                o = !1,
                n = $.extend({}, l, {
                    centerMode: !1,
                    adaptiveHeight: !0
                });

            function r(e, t) {
                o && (e.slick("unslick"), o = !1), e.slick(t), o = !0
            }
            c.slideCount = s.data("count"), c.slideCount < l.slidesToShow && (l.slidesToShow = c.slideCount, l.slidesToScroll = c.slideCount), s.on("init", this.a11y.bind(this)), enquire.register(c.mediaQuerySmall, {
                match: function() {
                    r(s, n)
                }
            }), enquire.register(c.mediaQueryMediumUp, {
                match: function() {
                    r(s, l)
                }
            })
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {
                enquire.unregister(c.mediaQuerySmall), enquire.unregister(c.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick")
            },
            a11y: function(e, t) {
                var i = t.$list,
                    a = $(this.wrapper, this.$container);
                i.removeAttr("aria-live"), a.on("focusin", function(e) {
                    a.has(e.target).length && i.attr("aria-live", "polite")
                }), a.on("focusout", function(e) {
                    a.has(e.target).length && i.removeAttr("aria-live")
                })
            }
        }), e
    }(), theme.slideshows = {}, theme.SlideshowSection = function(e) {
        var t = (this.$container = $(e)).attr("data-section-id"),
            i = this.slideshow = "#Slideshow-" + t;
        $(".slideshow__video", i).each(function() {
            var e = $(this);
            theme.SlideshowVideo.init(e), theme.SlideshowVideo.loadVideo(e.attr("id"))
        }), theme.slideshows[i] = new theme.Slideshow(i)
    }, theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow]
        },
        onBlockSelect: function(e) {
            var t = $(this.slideshow),
                i = $(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            t.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slideshow).slick("slickPlay")
        }
    }), theme.Instagram = function() {
        function e(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.settings = {
                template: '<a class="item" href="{{href}}" target="_blank"><span class="meta"><span class="likes">{{likes}}</span><span class="comments">{{comments}}</span></span><img class="lazyload" src="{{src}}" data-srcset="{{srcset}}" /></a>',
                accessToken: t.data("access_token"),
                count: t.data("count"),
                selector: "#instagram-" + i
            }, "" != this.settings.accessToken && 0 != this.settings.count && this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                var r = this,
                    t = r._buildUrl();
                $.get(t, function(e) {
                    if ("object" == typeof e && 200 == e.meta.code && 0 < e.data.length) {
                        var t = e.data,
                            a = "";
                        for (i = 0, len = t.length; i < len; i++) {
                            var s = t[i],
                                o = s.images.thumbnail.url,
                                n = s.images.thumbnail.url + " 150w, " + s.images.low_resolution.url + " 320w, " + s.images.standard_resolution.url + " 480w";
                            a += r._makeTemplate(r.settings.template, {
                                href: s.link,
                                src: o,
                                srcset: n,
                                likes: s.likes.count,
                                comments: s.comments.count
                            })
                        }
                        $(r.settings.selector).append(a)
                    }
                })
            },
            _buildUrl: function() {
                var e;
                return "https://api.instagram.com/v1", "users/self/media/recent", e = "https://api.instagram.com/v1/users/self/media/recent", e += "?access_token=" + this.settings.accessToken, e += "&count=" + this.settings.count
            },
            _makeTemplate: function(e, t) {
                var i, a, s, o, n;
                for (a = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = e; a.test(i);) o = i.match(a)[1], n = null != (s = this._getObjectProperty(t, o)) ? s : "", i = i.replace(a, function() {
                    return "" + n
                });
                return i
            },
            _getObjectProperty: function(e, t) {
                var i, a;
                for (a = (t = t.replace(/\[(\w+)\]/g, ".$1")).split("."); a.length;) {
                    if (i = a.shift(), !(null != e && i in e)) return null;
                    e = e[i]
                }
                return e
            },
            onUnload: function() {}
        }), e
    }(), theme.CountdownTimer = function() {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.settings = {
                selector: ".countdown-" + t + ":not(.is-countdown)"
            }, this.regional(), this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            regional: function() {
                $.countdown.regionalOptions.roar = {
                    labels: ["Years", "Months", "Weeks", theme.strings.days, theme.strings.hours, theme.strings.minutes, theme.strings.seconds],
                    labels1: ["Year", "Month", "Week", theme.strings.day, theme.strings.hour, theme.strings.minute, theme.strings.second],
                    compactLabels: ["y", "m", "w", "d"],
                    whichLabels: null,
                    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                    timeSeparator: ":",
                    isRTL: theme.settings.rtl
                }, $.countdown.setDefaults($.countdown.regionalOptions.roar)
            },
            init: function(e) {
                $(this.settings.selector).each(function() {
                    var e = $(this);
                    if ("" != e.data("end_date")) {
                        var t = e.data("end_date").split("-"),
                            i = new Date(t[2], parseInt(t[0]) - 1, t[1]);
                        new Date;
                        e.countdown({
                            until: i,
                            alwaysExpire: !0,
                            onExpiry: function() {
                                e.hide()
                            }
                        })
                    }
                })
            },
            onUnload: function() {}
        }), e
    }(), theme.NewsletterPopup = function() {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.settings = {
                selector: "#newsletter-popup-" + t
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                try {
                    var t = $(this.settings.selector),
                        s = t.data("period"),
                        i = t.data("delay"),
                        a = t.data("version");
                    if (0 < s && document.cookie.match(/^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/)) return;

                    function o() {
                        $(document.body).removeClass("newsletter-opened").removeClass("newsletter2-opened"), $(document.body).trigger("roarNewsletter_closed", [t])
                    }
                    $(window).on("load", function() {
                        setTimeout(function() {
                            "popup2" == a ? $(document.body).addClass("newsletter2-opened") : $(document.body).addClass("newsletter-opened")
                        }, 1e3 * i)
                    }), $(document.body).on("roarNewsletter_closed", function(e, t) {
                        var i = new Date,
                            a = i.getTime();
                        i.setTime(i.getTime() + 24 * s * 60 * 60 * 1e3), document.cookie = "roarStorage_newsletter=" + a + ";expires=" + i.toGMTString() + ";path=/"
                    }), $(document.body).on("click", ".newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop", function(e) {
                        e.preventDefault(), o()
                    }), $(document).on("keyup", function(e) {
                        27 === e.keyCode && o()
                    })
                } catch (e) {
                    return
                }
            },
            onUnload: function() {}
        }), e
    }(), theme.ProductsParallax = function() {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.settings = {
                selector: "#products-parallax-" + t
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                $(this.settings.selector).RoarMasonryAnimate({
                    columns: ".products-parallax__col",
                    items: ".products-parallax__item",
                    respEl: ".products-parallax-split",
                    moveEl: ".products-parallax-move"
                })
            },
            onUnload: function() {}
        }), e
    }(), theme.ProductSlider = function() {
        function e(e) {
            var t = (this.$container = $(e)).attr("data-section-id");
            this.settings = {
                selector: ".slick-slider-" + t + ":not(.slick-initialized)"
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                $(this.settings.selector).each(function() {
                    var i = $(this),
                        a = i.data("max_pages"),
                        s = i.data("cat_id");
                    if (!(a < 2 || "" == s)) {
                        var o = i.closest(".products-slider"),
                            n = {},
                            r = i.data("grid_num"),
                            c = i.data("grid_row"),
                            e = {
                                rtl: theme.settings.rtl,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: !1,
                                infinite: !0
                            };
                        i.slick(e), o.find(".slick-prev").off("click").on("click", function(e) {
                            e.preventDefault(), i.slick("slickPrev")
                        }), o.find(".slick-next").off("click").on("click", function(e) {
                            e.preventDefault();
                            var t = i.slick("slickCurrentSlide") + 2;
                            t <= a ? n[t] ? i.slick("slickNext") : o.hasClass("loading") || o.hasClass("finished") || $.ajax({
                                url: "/collections/" + s,
                                type: "GET",
                                dataType: "html",
                                data: {
                                    view: "custom",
                                    limit: r + "*" + c,
                                    page: t
                                },
                                beforeSend: function() {
                                    o.addClass("loading")
                                },
                                complete: function() {
                                    o.removeClass("loading")
                                },
                                success: function(e) {
                                    $(e).find(".product").length ? (i.slick("slickAdd", e), i.slick("slickNext"), n[t] = !0, 0 == $(e).data("is_next") && o.addClass("finished")) : o.addClass("finished")
                                }
                            }) : i.slick("slickNext")
                        })
                    }
                })
            }
        }), e
    }(), theme.ProductTab = function() {
        function e(e) {
            (this.$container = $(e)).attr("data-section-id");
            this.selectors = {
                container: ".tabs__container",
                title: ".tabs__title",
                panel: ".tabs__panel"
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function(e) {
                var r = this;
                $(document).on("click", r.selectors.title, function(e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.closest(r.selectors.container),
                        a = $(t.attr("href")),
                        s = a.find(".slick-slider"),
                        o = i.find(r.selectors.title),
                        n = i.find(r.selectors.panel);
                    o.removeClass("active"), n.removeClass("active"), t.addClass("active"), a.addClass("active"), s.hasClass("slick-initialized") && s.slick("setPosition")
                })
            }
        }), e
    }();
var roarLookbook = {
    getSizedImageUrl: function(e, t) {
        if ((a = document.createElement("a")).href = e, "cdn.shopify.com" != a.hostname) return e;
        if (null == t) return e;
        if ("master" == t) return roarLookbook.removeProtocol(e);
        var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != i) {
            var a = e.split(i[0]),
                s = i[0];
            return roarLookbook.removeProtocol(a[0] + "_" + t + s)
        }
        return null
    },
    removeProtocol: function(e) {
        return e.replace(/http(s)?:/, "")
    },
    isProductUrl: function(e) {
        var t = window.location.hostname,
            i = document.createElement("a");
        return i.href = e, i.hostname == t
    },
    buildLookbook: function() {
        $(".roarlookbook").each(function(i) {
            var a = $(this);
            if (!a.hasClass("roarlookbook_init")) {
                var s = a.attr("data-lookbook"),
                    e = {
                        lookbook: s,
                        action: "lookbook_get"
                    };
                e = $.param(e), $.ajax({
                    type: "POST",
                    url: "/apps/roarlookbook",
                    async: !0,
                    cache: !1,
                    data: e,
                    dataType: "json",
                    beforeSend: function() {},
                    error: function(e) {},
                    success: function(e) {
                        a.append(e);
                        var t = a.find(".media__blank-preview");
                        t.imagesLoaded(function() {
                            a.addClass("roarlookbook_init").attr("data-lookbook", s + i), t.addClass("sfx-fadeIn")
                        })
                    }
                })
            }
        })
    },
    resetHotspots: function(a) {
        var e = $(".hotspot", a),
            s = a.attr("data-lookbook");
        e.each(function() {
            var e = $(this),
                t = e.attr("data-id"),
                i = $("#" + s + "-" + t, a);
            i.fadeOut("fast", function() {
                i.remove(), e.removeClass("hotspot_init")
            })
        })
    },
    hotspotPopup: function() {
        $(".roarlookbook").on("click", ".hotspot", function(e) {
            var c = $(this);
            if (c.hasClass("hotspot_init")) {
                l = c.closest(".roarlookbook");
                roarLookbook.resetHotspots(l)
            } else {
                var l = c.closest(".roarlookbook"),
                    t = c.attr("data-id"),
                    i = c.closest(".roarlookbook").attr("data-lookbook") + "-" + t,
                    d = "#" + c.closest(".roarlookbook").attr("data-lookbook") + "-" + t,
                    a = c.attr("data-title"),
                    s = c.attr("data-image"),
                    o = c.attr("data-price"),
                    n = c.attr("data-url"),
                    r = "";
                if ("" == a && "" == n) return !1;
                if (roarLookbook.resetHotspots(l), r += '<div id="' + i + '" class="hotspot-widget hotspot-loading">', r += '<div class="hotspot-content">', r += '<span class="hotspot-close">×</span>', r += '<div class="hotspot-inner">', "" != s) {
                    var u = '<img src="' + roarLookbook.getSizedImageUrl(s, "80x") + '" src="' + roarLookbook.getSizedImageUrl(s, "300x") + '" data-srcset="' + roarLookbook.getSizedImageUrl(s, "300x") + " 1x, " + roarLookbook.getSizedImageUrl(s, "600x") + ' 2x" alt="" />';
                    r += "" != n ? '<a href="' + n + '">' + u + "</a>" : u
                }
                if ("" != a && (r += "<h3>", r += "" != n ? '<a href="' + n + '">' + a + "</a>" : a, r += "</h3>"), "" != o && (r += '<div class="price"><span class="money">' + o + "</span></div>", roarLookbook.isProductUrl(n) && (r += '<div class="hotspot-btns">', r += '<div class="hotspot-btn"><a href="' + n + '">' + theme.apps.details + "</a></div>", r += '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' + n + '?add-to-cart=true">' + theme.apps.buyNow + "</a></div>", r += "</div>")), r += "</div>", r += "</div>", r += "</div>", $(d).length || l.append(r), $(d).imagesLoaded(function() {
                        var e = $(d),
                            t = c.offset().left,
                            i = c.offset().top,
                            a = e.outerWidth(),
                            s = e.outerHeight(),
                            o = l.offset().left,
                            n = l.offset().top,
                            r = (l.outerWidth(), "hotspot-right");
                        a + 5 < t ? (t = t - a - 5, r = "hotspot-left") : t = t + c.outerWidth() + 5, i = i + c.outerHeight() / 2 - s / 2, e.css({
                            left: t - o,
                            top: i - n
                        }).removeClass("hotspot-left").removeClass("hotspot-right").addClass(r), c.addClass("hotspot_init"), e.removeClass("hotspot-loading").fadeIn("fast")
                    }), $(d).find("img").length) {
                    var h = $(d).find("img");
                    h.attr("src", h.attr("data-src")).removeAttr("data-src").attr("srcset", h.attr("data-srcset")).removeAttr("data-srcset")
                }
            }
        }), $(document).on("click", ".hotspot-close", function(e) {
            var t = $(this).closest(".hotspot-widget"),
                i = t.attr("id").split("-")[1];
            $('.roarlookbook .hotspot[data-id="' + i + '"]').removeClass("hotspot_init"), t.fadeOut("fast", function() {
                t.remove()
            })
        }), $(".roarlookbook").on("click", ".image-preview", function(e) {
            var t = $(this).closest(".roarlookbook");
            roarLookbook.resetHotspots(t)
        }), $(window).resize(function(e) {
            $(".roarlookbook .hotspot_init").length && $(".roarlookbook .hotspot_init").each(function() {
                $(this).removeClass("hotspot_init").trigger("click")
            })
        })
    },
    addToCart: function() {
        $(document).on("click", ".roar_add_to_cart", function(e) {
            e.preventDefault();
            var t = $(this),
                i = t.closest(".roarlookbook"),
                a = t.attr("href");
            $.ajax({
                type: "GET",
                url: a,
                beforeSend: function() {},
                success: function(e) {
                    $(e).find('form[action="/cart/add"]').appendTo(i).submit().remove()
                },
                dataType: "html"
            })
        })
    },
    init: function() {
        $(".roarlookbook").length && (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart())
    }
};
theme.roarJs = function() {
    function p(e, t, i) {
        void 0 === i && (i = !1), $(".alert__message").remove();
        var a = '<div class="alert__message"><div class="alert__icon"><i class="' + e + '"></i></div><div class="alert__content">' + t + "</div></div>";
        1 == i && (a = '<div class="alert__message cart_message"><div class="alert__background" style="background-image:url(' + e + ');"></div><div class="alert__description">' + t + "</div></div>"), $("body").append(a)
    }

    function l(e, t, i, a) {
        var s = ".cd-quick-view",
            o = e.closest(".product__item"),
            n = e.offset().top - $(window).scrollTop(),
            r = e.offset().left,
            c = e.width(),
            l = e.height(),
            d = $(window).width(),
            u = (d - t) / 2,
            h = ($(window).height() - t * l / c) / 2 + 30,
            p = .8 * d < i ? .8 * d : i,
            m = (d - p) / 2;
        "open" == a ? ($("body").addClass("overlay-layer"), o.addClass("empty-box"), $(s).css({
            top: n,
            left: r,
            width: c
        }).velocity({
            top: h + "px",
            left: u + "px",
            width: t + "px"
        }, 1e3, [400, 20], function() {
            $(s).addClass("animate-width").velocity({
                left: m + "px",
                width: p + "px"
            }, 300, "ease", function() {
                $(s).addClass("add-content"), (new theme.Sections).register("product-quickview", theme.Product), Shopify.PaymentButton.init(), f()
            })
        }).addClass("is-visible")) : $(s).removeClass("add-content").velocity({
            top: h + "px",
            left: u + "px",
            width: t + "px"
        }, 300, "ease", function() {
            $("body").removeClass("overlay-layer"), $(s).removeClass("animate-width").velocity({
                top: n,
                left: r,
                width: c
            }, 500, "ease", function() {
                $(s).removeClass("is-visible"), o.removeClass("empty-box")
            })
        })
    }

    function t(e, t) {
        var i, a, s, o, n, r = $(".cd-close").siblings(".cd-slider-wrapper").find(".selected img").attr("src"),
            c = $(".empty-box").find(".product__image");
        c.length && (!$(".cd-quick-view").hasClass("velocity-animating") && $(".cd-quick-view").hasClass("add-content") ? (c.attr("src", r), l(c, e, t, "close")) : (a = (i = c).closest(".product__item"), s = i.offset().top - $(window).scrollTop(), o = i.offset().left, n = i.width(), $("body").removeClass("overlay-layer"), a.removeClass("empty-box"), $(".cd-quick-view").velocity("stop").removeClass("add-content animate-width is-visible").css({
            top: s,
            left: o,
            width: n
        })))
    }

    function f() {
        var e = ".cd-quick-view",
            t = ($(window).width() - $(e).width()) / 2,
            i = ($(window).height() - $(e).height()) / 2;
        $(e).css({
            top: i,
            left: t
        })
    }

    function n() {
        var e = $("body"),
            i = $(".cart__fullscreen"),
            a = $(".cart__fullscreen .cart__info");
        e.addClass("cart-opened"), i.show(), setTimeout(function() {
            i.addClass("opened")
        }, 100), $.ajax({
            url: "/cart?view=popup",
            dataType: "html",
            type: "GET",
            beforeSend: function() {
                i.addClass("loading")
            },
            complete: function() {
                setTimeout(function() {
                    i.removeClass("loading")
                }, 100)
            },
            success: function(e) {
                a.empty().html(e), i.addClass("loaded");
                new Date;
                var t = new theme.Sections;
                t.register("cart-popup", theme.Cart), t.register("cart-gift-popup", theme.CartGift), t.register("shipping-calculator-popup", theme.ShippingCalculator)
            }
        })
    }

    function e() {
        $(document).on("click", ".addcompare_btn", function(e) {
            e.preventDefault();
            var t = $(this),
                i = t.data("product_handle"),
                a = localStorage.getItem("roarStorage_compare");
            (a = null != a && "" != a ? a.split(",") : new Array).indexOf(i) < 0 && (a.length < 20 ? (a.push(i), "," == (a = a.join(",")).substring(0, 1) && (a = a.substring(1)), localStorage.setItem("roarStorage_compare", a)) : p("icon_error-triangle_alt", theme.strings.compareLimit)), "string" != typeof a && "," == (a = a.join(",")).substring(0, 1) && (a = a.substring(1)), $.ajax({
                url: "/search?view=compare&q=" + a,
                dataType: "html",
                type: "GET",
                beforeSend: function() {
                    t.addClass("adding")
                },
                complete: function() {
                    t.removeClass("adding")
                },
                success: function(e) {
                    ! function(e) {
                        $("body").addClass("compare-opened");
                        var t = $(".compare__fullscreen");
                        t.removeClass("opened"), t.find(".compare__content").empty().html(e), t.addClass("opened"), $(".compare__list tr").each(function() {
                            $(this).css("height", $(this).outerHeight())
                        }), $(".compare__list").clone().appendTo(".compare__left"), $(".compare__left td").remove()
                    }(e), t.addClass("added")
                }
            })
        })
    }
    return {
        init: function() {
            var s, a, o;
            $("#site-loader").length && (NProgress.configure({
                    template: '<div class="bar" role="bar"></div>',
                    parent: "#site-loader",
                    showSpinner: !1,
                    easing: "ease",
                    minimum: .3,
                    speed: 500
                }), NProgress.start(), $(window).on("pagehide", function(e) {
                    e.persisted && ($("#site-container").addClass("loading").removeClass("loaded"), $("#site-loader").removeClass("loaded"))
                }), $(window).load(function(e) {
                    $("#site-container").addClass("loaded").removeClass("loading"), $("#site-loader").addClass("loaded"), NProgress.done()
                })), ! function(e) {
                    try {
                        for (var t = e + "=", i = document.cookie.split(";"), a = 0; a < i.length; a++) {
                            for (var s = i[a];
                                " " == s.charAt(0);) s = s.substring(1, s.length);
                            if (0 == s.indexOf(t)) return s.substring(t.length, s.length)
                        }
                        return null
                    } catch (e) {
                        return null
                    }
                }("roarStorage_isAnAdult") ? $("#age__check").show() : $("#age__check").remove(), $(document).on("click", "#age__check .btn-birthdate", function() {
                    var e = new Date;
                    e.setTime(e.getTime() + 12096e5);
                    var t = "; expires=" + e.toGMTString();
                    document.cookie = "roarStorage_isAnAdult=true;" + t + "; path=/", $("#age__check").remove()
                }), roarLookbook.init(), $(".lookbook-listing.is-slider").length && $(".lookbook-listing.is-slider").each(function() {
                    var t = $(this),
                        i = {
                            centerMode: !0,
                            centerPadding: "20%",
                            slidesToShow: 1
                        },
                        a = t.find(".lookbook__item").length,
                        s = setInterval(function() {
                            var e = t.find("img.image-preview").length;
                            a <= e && (t.imagesLoaded(function() {
                                setTimeout(function() {
                                    t.slick(i)
                                }, 500)
                            }), clearInterval(s))
                        }, 300)
                }), $(".slick__gallery").each(function() {
                    $(this).slick({
                        rtl: theme.settings.rtl
                    })
                }), $(".soundcloud__audio").each(function() {
                    var t = $(this),
                        e = {
                            async: !0,
                            crossDomain: !0,
                            url: "https://soundcloud.com/oembed",
                            method: "GET",
                            headers: {},
                            data: {
                                format: "json",
                                url: t.data("video")
                            }
                        };
                    $.ajax(e).done(function(e) {
                        t.replaceWith(e.html)
                    })
                }), $(document).on("click", ".sidebar__btn, .sidebar__close, .sidebar__overlay", function() {
                    $("body").hasClass("sidebar-open") ? ($("body").removeClass("sidebar-open"), $(".shop__filtering").slideUp()) : ($("body").addClass("sidebar-open"), $(".shop__filtering").slideDown())
                }), $(document).on("click", ".header__toggle", function() {
                    $(this).toggleClass("active"), $(".collection-header ul").slideToggle()
                }), $(".cd-quick-view").length || $("body").append('<div class="cd-quick-view"></div>'), $(document).on("click", ".quickview_btn", function(e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.data("collection_handle"),
                        a = t.data("product_handle"),
                        s = t.closest(".product__item").find(".product__image");
                    s.css("background-image").replace(/^url\(['"](.+)['"]\)/, "$1"), $.ajax({
                        url: "/collections/" + i + "/products/" + a + "?view=quickview",
                        beforeSend: function() {
                            t.addClass("adding")
                        },
                        complete: function() {
                            t.removeClass("adding")
                        },
                        success: function(e) {
                            $(".cd-quick-view").empty().html(e), l(s, 480, 960, "open")
                        }
                    })
                }), $("body").on("click", function(e) {
                    ($(e.target).is(".cd-close") || $(e.target).is("body.overlay-layer")) && t(480, 960)
                }), $(document).keyup(function(e) {
                    "27" == e.which && t(480, 960)
                }), $(window).on("resize", function() {
                    $(".cd-quick-view").hasClass("is-visible") && window.requestAnimationFrame(f)
                }),
                function() {
                    if ("fullcart" == theme.settings.afterAddition && !$(".cart__fullscreen").length) {
                        var e = '<div class="cart__fullscreen"><div class="cart__overlay"></div><div class="cart__container"><div class="cart__close">×</div><div class="cart__content"><h2 class="page-heading">' + theme.strings.shoppingCart + '</h2><div class="cart__info"></div></div></div></div>';
                        $("body").append(e)
                    }
                    $(document).on("click", ".cart__close, .cart__overlay", function() {
                        var e = $("body"),
                            t = $(".cart__fullscreen");
                        t.removeClass("opened").removeClass("loaded").addClass("removing"), setTimeout(function() {
                            t.hide().removeClass("removing"), e.removeClass("cart-opened")
                        }, 250), 0 === location.pathname.indexOf("/cart") && location.reload()
                    })
                }(), $(document).on("click", ".addcart_btn:not(.added), .product-form__cart-submit", function(e) {
                    e.preventDefault();
                    var s = $(this),
                        t = s.closest("form");
                    return 1 != theme.settings.cartAjax ? t.submit() : $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !0,
                        cache: !1,
                        data: t.serialize(),
                        dataType: "json",
                        beforeSend: function() {
                            s.addClass("adding")
                        },
                        complete: function(e) {
                            if (s.removeClass("adding"), "redirect" == theme.settings.afterAddition) return !(window.location = "/cart");
                            if ("message" == theme.settings.afterAddition) {
                                var t = e.responseJSON;
                                if (void 0 !== t.id) {
                                    var i = theme.Images.getSizedImageUrl(t.image, "200x"),
                                        a = t.title;
                                    p(i, theme.strings.productAdded.replace("{{ product_name }}", a), !0)
                                } else p("icon_error-triangle_alt", t.message + ": " + t.description)
                            }
                        },
                        success: function(e) {
                            s.addClass("added"), theme.MiniCart.update(), "minicart" == theme.settings.afterAddition ? theme.MiniCart.open() : "fullcart" == theme.settings.afterAddition && n()
                        }
                    }), !1
                }), $(document).on("click", ".product-form__cart-submit--grouped", function(e) {
                    e.preventDefault();
                    var t = $(this),
                        i = t.closest(".product-single__content").find(".product-single__grouped .product-form__input");
                    return i.length && (Shopify.queue = [], i.each(function() {
                        0 < parseInt($(this).val()) && Shopify.queue.push({
                            variantId: $(this).data("variant_id"),
                            quantity: parseInt($(this).val())
                        })
                    }), Shopify.moveAlong = function() {
                        if (Shopify.queue.length) {
                            var e = Shopify.queue.shift();
                            Shopify.addItem(e.variantId, e.quantity, e.properties, Shopify.moveAlong)
                        } else t.removeClass("adding"), theme.MiniCart.update(), "redirect" == theme.settings.afterAddition ? location.href = "/cart" : "minicart" == theme.settings.afterAddition ? theme.MiniCart.open() : "fullcart" == theme.settings.afterAddition && n()
                    }, Shopify.addItem = function(e, t, i, a) {
                        var s = {
                            quantity: t,
                            id: e
                        };
                        0 != i && (s.properties = i), $.ajax({
                            type: "POST",
                            url: "/cart/add.js",
                            dataType: "json",
                            data: s,
                            success: function() {
                                "function" == typeof a && a()
                            },
                            error: function() {}
                        })
                    }, Shopify.queue.length && (t.addClass("adding"), Shopify.moveAlong())), !1
                }), $(document).on("click", ".products-grid .product__item .options_btn", function(e) {
                    var t = $(this).closest(".product__item");
                    750 < $(window).width() && (e.preventDefault(), t.addClass("opened"))
                }), $(document).on("click", ".products-grid .product__item .close_btn", function(e) {
                    var t = $(this).closest(".product__item");
                    750 < $(window).width() && (e.preventDefault(), t.removeClass("opened"))
                }), $(document).on("click", ".addwishlist_btn:not(.added)", function(e) {
                    e.preventDefault();
                    var i = $(this),
                        t = parseInt(i.data("customer_id"));
                    if (0 < t) {
                        var a = i.data("shop_domain"),
                            s = parseInt(i.data("product_id")),
                            o = i.data("product_handle");
                        if (a.length && o.length && s) {
                            var n = document.createElement("form");
                            n.setAttribute("action", "/contact"), n.setAttribute("method", "POST"), n.setAttribute("style", "display:none");
                            var r = document.createElement("input");
                            r.setAttribute("type", "hidden"), r.setAttribute("name", "customer"), r.setAttribute("value", t);
                            var c = document.createElement("input");
                            c.setAttribute("type", "hidden"), c.setAttribute("name", "shop"), c.setAttribute("value", a);
                            var l = document.createElement("input");
                            l.setAttribute("type", "hidden"), l.setAttribute("name", "id"), l.setAttribute("value", s);
                            var d = document.createElement("input");
                            d.setAttribute("type", "hidden"), d.setAttribute("name", "handle"), d.setAttribute("value", o);
                            var u = document.createElement("input");
                            u.setAttribute("type", "hidden"), u.setAttribute("name", "action"), u.setAttribute("value", "add_wishlist"), n.appendChild(r), n.appendChild(c), n.appendChild(l), n.appendChild(d), n.appendChild(u), $("body").append(n);
                            var h = $(n).serialize();
                            $.ajax({
                                type: "POST",
                                url: "/a/wishlist",
                                async: !0,
                                cache: !1,
                                data: h,
                                dataType: "json",
                                beforeSend: function() {
                                    i.addClass("adding")
                                },
                                complete: function() {
                                    i.removeClass("adding")
                                },
                                success: function(e) {
                                    if (p("icon_check", theme.strings.wishlistAdded), i.addClass("added"), $(n).remove(), 1 == e.code) {
                                        var t = parseInt(e.json);
                                        t ? $(".wishlist__count").removeClass("hide").text(t) : $(".wishlist__count").addClass("hide").text(0)
                                    }
                                }
                            })
                        }
                    } else window.location = "/account/login"
                }), $(document).on("click", ".removewishlist_btn", function() {
                    var i = $(this),
                        e = parseInt(i.data("customer_id"));
                    if (0 < e) {
                        var t = i.data("shop_domain"),
                            a = parseInt(i.data("product_id"));
                        if (t.length && a) {
                            var s = document.createElement("form");
                            s.setAttribute("action", "/contact"), s.setAttribute("method", "POST"), s.setAttribute("style", "display:none");
                            var o = document.createElement("input");
                            o.setAttribute("type", "hidden"), o.setAttribute("name", "customer"), o.setAttribute("value", e);
                            var n = document.createElement("input");
                            n.setAttribute("type", "hidden"), n.setAttribute("name", "shop"), n.setAttribute("value", t);
                            var r = document.createElement("input");
                            r.setAttribute("type", "hidden"), r.setAttribute("name", "product"), r.setAttribute("value", a);
                            var c = document.createElement("input");
                            c.setAttribute("type", "hidden"), c.setAttribute("name", "action"), c.setAttribute("value", "remove_wishlist"), s.appendChild(o), s.appendChild(n), s.appendChild(r), s.appendChild(c), $("body").append(s);
                            var l = $(s).serialize();
                            $.ajax({
                                type: "POST",
                                url: "/a/wishlist",
                                async: !0,
                                cache: !1,
                                data: l,
                                dataType: "json",
                                beforeSend: function() {
                                    $(".wishlist__table").addClass("loading")
                                },
                                complete: function() {
                                    $(".wishlist__table").removeClass("loading")
                                },
                                success: function(e) {
                                    if ($(s).remove(), 1 == e.code) {
                                        var t = parseInt(e.json);
                                        t ? i.closest("tr").slideUp("fast", function() {
                                            $(this).remove(), p("icon_check", theme.strings.wishlistRemoved), $(".wishlist__count").removeClass("hide").text(t)
                                        }) : location.reload()
                                    }
                                }
                            })
                        }
                    } else window.location = "/account/login"
                }),
                function() {
                    if ($(".addcompare_btn").length) {
                        try {
                            var i = localStorage.getItem("roarStorage_compare");
                            null != i && "" != i && (i = i.split(","), $(".addcompare_btn").each(function() {
                                var e = $(this),
                                    t = e.data("product_handle");
                                0 <= i.indexOf(t) && e.addClass("added")
                            }))
                        } catch (e) {
                            return
                        }
                        $(".compare__fullscreen").length || $("body").append('<div class="compare__fullscreen"><div class="compare__container"><div class="compare__close">×</div><div class="compare__content"></div></div></div>'), $(document).on("click", ".compare__close", function() {
                            $("body").removeClass("compare-opened"), $(".compare__fullscreen").removeClass("opened")
                        }), $(document).keyup(function(e) {
                            "27" == e.which && $(".compare__fullscreen").hasClass("opened") && $(".compare__close").trigger("click")
                        })
                    }
                }(), e(), $(document).on("click", ".removecompare_btn", function() {
                    var e = $(this),
                        t = e.data("product_id"),
                        i = e.data("product_handle"),
                        a = ".product__" + t,
                        s = localStorage.getItem("roarStorage_compare");
                    null != s && "" != s && 0 <= (s = s.split(",")).indexOf(i) && (s = $.grep(s, function(e) {
                        return e != i
                    }), s = $.trim(s), localStorage.setItem("roarStorage_compare", s)), "" != s ? $(".compare__list " + a).remove() : $(".compare__close").trigger("click"), $(a + " .addcompare_btn").removeClass("added")
                }), $(window).scroll(function() {
                    1024 < $(window).width() && $(".article-header .header__overlay").length && $(".article-header .header__overlay").css("opacity", .3 + $(window).scrollTop() / (1.4 * $(window).height()))
                }), $(document).on("click", ".alert__message", function() {
                    $(this).hide(), $(this).hasClass("cart_message") && "message" == theme.settings.afterAddition && theme.MiniCart.open()
                }), $(document).on("click", ".password-login", function(e) {
                    e.preventDefault(), $("body").addClass("password-opened"), setTimeout(function() {
                        $(".password-modal input").focus()
                    }, 250)
                }), $(document).on("click", ".password-modal .modal__close", function() {
                    $("body").removeClass("password-opened")
                }), $(document).keyup(function(e) {
                    27 == e.keyCode && $("body").removeClass("password-opened")
                }), $(".password-modal").find(".errors").length && ($("body").addClass("password-opened"), setTimeout(function() {
                    $(".password-modal input").focus()
                }, 250)), s = ["/cart?", "/search?", "/collections/"], $(document).ajaxComplete(function(e, t, i) {
                    if (function(e, t) {
                            for (var i = 0; i < t.length; i++)
                                if (e.match((".*" + t[i].trim() + ".*").replace(" ", ".*"))) return !0;
                            return !1
                        }(i.url, s)) {
                        theme.CurrencyPicker.convertAll(), theme.roarJs.initReviews();
                        var a = new theme.Sections;
                        a.register("line_item", theme.LineItem), a.register("countdown-timer", theme.CountdownTimer)
                    }
                }), a = ".totop_btn", o = ".site-header__mobile", $(a).length && ($(window).scroll(function() {
                    var e = $(this).scrollTop(),
                        t = $(this).height();
                    if ($(o).is(":visible")) e < (t = $(o).offset().top + $(o).height()) ? $(a).removeClass("on") : $(a).addClass("on");
                    else {
                        var i = 1;
                        0 < e && (i = e + t / 2), i < 1e3 ? $(a).removeClass("on") : $(a).addClass("on")
                    }
                }), $(a).click(function(e) {
                    e.preventDefault(), $("html,body").animate({
                        scrollTop: 0
                    }, 800, "swing")
                }))
        },
        backHistory: function() {
            history.go(-1)
        },
        initReviews: function() {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        }
    }
}(), $(document).ready(function() {
    var e = new theme.Sections;
    e.register("cart-template", theme.Cart), e.register("cart-gift", theme.CartGift), e.register("shipping-calculator", theme.ShippingCalculator), e.register("collection-template", theme.Filters), e.register("product-template", theme.Product), e.register("header-mobile", theme.HeaderMobile), e.register("header-section", theme.HeaderSection), e.register("map", theme.Maps), e.register("slideshow-section", theme.SlideshowSection), e.register("quotes", theme.Quotes), e.register("line_item", theme.LineItem), e.register("instagram", theme.Instagram), e.register("countdown-timer", theme.CountdownTimer), e.register("product-slider", theme.ProductSlider), e.register("product-tab", theme.ProductTab), e.register("newsletter-popup", theme.NewsletterPopup), e.register("products-parallax", theme.ProductsParallax)
}), theme.init = function() {
    theme.roarJs.init(), theme.customerTemplates.init();
    slate.rte.wrapTable({
        $tables: $(".rte table,.custom__item-inner--html table"),
        tableWrapperClass: "scrollable-wrapper"
    });
    slate.rte.wrapIframe({
        $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
        iframeWrapperClass: "video-wrapper"
    }), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash))
    }), $('a[href="#"]').on("click", function(e) {
        e.preventDefault()
    }), $(".roar_themedemo-box").on("click", function(e) {
        var t = $(this),
            i = $("html");
        t.hasClass("active") ? (t.removeClass("active"), i.removeClass("is-boxed")) : (t.addClass("active"), i.addClass("is-boxed"))
    }), $(".roar_themedemo-rtl").on("click", function(e) {
        var t = $(this),
            i = $("body");
        t.hasClass("active") ? (t.removeClass("active"), i.removeClass("is-rtl").removeClass("is-rtl_demo")) : (t.addClass("active"), i.addClass("is-rtl").addClass("is-rtl_demo"))
    })
}, $(theme.init);